// jQuery bought in via frame
/*
* jQuery Mobile Framework : events
* Copyright (c) jQuery Project
* Dual licensed under the MIT or GPL Version 2 licenses.
* http://jquery.org/license
*/
(function($, undefined ) {
    $.extend( $.support, {
    orientation: "orientation" in window,
    touch: "ontouchend" in document
    });

    // add new event shortcuts
    $.each( "touchstart touchmove touchend orientationchange tap taphold swipe swipeleft swiperight scrollstart scrollstop".split( " " ), function( i, name ) {
    $.fn[ name ] = function( fn ) {
        return fn ? this.bind( name, fn ) : this.trigger( name );
    };
    });

    var supportTouch = $.support.touch,
    scrollEvent = "touchmove scroll",
    touchStartEvent = supportTouch ? "touchstart" : "mousedown",
    touchStopEvent = supportTouch ? "touchend" : "mouseup",
    touchMoveEvent = supportTouch ? "touchmove" : "mousemove";

    // also handles scrollstop
    $.event.special.scrollstart = {
    enabled: true,

    setup: function() {
        var thisObject = this,
            $this = $( thisObject ),
            scrolling,
            timer;

        function trigger( event, state ) {
            scrolling = state;
            var originalType = event.type;
            event.type = scrolling ? "scrollstart" : "scrollstop";
            $.event.dispatch.call( thisObject, event );
            event.type = originalType;
        }

        // iPhone triggers scroll after a small delay; use touchmove instead
        $this.bind( scrollEvent, function( event ) {
            if ( !$.event.special.scrollstart.enabled ) {
                return;
            }

            if ( !scrolling ) {
                trigger( event, true );
            }

            clearTimeout( timer );
            timer = setTimeout(function() {
                trigger( event, false );
            }, 50 );
        });
    }
    };

    // also handles taphold
    $.event.special.tap = {
    setup: function() {
        var thisObject = this,
            $this = $( thisObject );

        $this
            .bind( touchStartEvent, function( event ) {
                if ( event.which && event.which !== 1 ) {
                    return;
                }

                var moved = false,
                    touching = true,
                    origPos = [ event.pageX, event.pageY ],
                    originalType,
                    timer;

                function moveHandler() {
                    if ((Math.abs(origPos[0] - event.pageX) > 10) ||
                        (Math.abs(origPos[1] - event.pageY) > 10)) {
                        moved = true;
                    }
                }

                timer = setTimeout(function() {
                    if ( touching && !moved ) {
                        originalType = event.type;
                        event.type = "taphold";
                        $.event.dispatch.call( thisObject, event );
                        event.type = originalType;
                    }
                }, 750 );

                $this
                    .one( touchMoveEvent, moveHandler)
                    .one( touchStopEvent, function( event ) {
                        $this.unbind( touchMoveEvent, moveHandler );
                        clearTimeout( timer );
                        touching = false;

                        if ( !moved ) {
                            originalType = event.type;
                            event.type = "tap";
                            $.event.dispatch.call( thisObject, event );
                            event.type = originalType;
                        }
                    });
            });
    }
    };

    // also handles swipeleft, swiperight
    $.event.special.swipe = {
    setup: function() {
        var thisObject = this,
            $this = $( thisObject );

        $this
            .bind( touchStartEvent, function( event ) {
                var data = event.originalEvent.touches ?
                        event.originalEvent.touches[ 0 ] :
                        event,
                    start = {
                        time: (new Date).getTime(),
                        coords: [ data.pageX, data.pageY ],
                        origin: $( event.target )
                    },
                    stop;

                function moveHandler( event ) {
                    if ( !start ) {
                        return;
                    }

                    var data = event.originalEvent.touches ?
                            event.originalEvent.touches[ 0 ] :
                            event;
                    stop = {
                            time: (new Date).getTime(),
                            coords: [ data.pageX, data.pageY ]
                    };

                    // prevent scrolling
                    if ( Math.abs( start.coords[0] - stop.coords[0] ) > 10 ) {
                        event.preventDefault();
                    }
                }

                $(this)
                    .bind( touchMoveEvent, moveHandler )
                    .one( touchStopEvent, function( event ) {
                        $this.unbind( touchMoveEvent, moveHandler );
                        if ( start && stop ) {
                            if ( stop.time - start.time < 1000 &&
                                    Math.abs( start.coords[0] - stop.coords[0]) > 30 &&
                                    Math.abs( start.coords[1] - stop.coords[1]) < 75 ) {
                                start.origin
                                .trigger( "swipe" )
                                .trigger( start.coords[0] > stop.coords[0] ? "swipeleft" : "swiperight" );
                            }
                        }
                        start = stop = undefined;
                    });
            });
    }
    };

    (function($){
    // "Cowboy" Ben Alman

    var win = $(window),
        special_event,
        get_orientation,
        last_orientation;

    $.event.special.orientationchange = special_event = {
        setup: function(){
            // If the event is supported natively, return false so that jQuery
            // will bind to the event using DOM methods.
            if ( $.support.orientation ) { return false; }

            // Get the current orientation to avoid initial double-triggering.
            last_orientation = get_orientation();

            // Because the orientationchange event doesn't exist, simulate the
            // event by testing window dimensions on resize.
            win.bind( "resize", handler );
        },
        teardown: function(){
            // If the event is not supported natively, return false so that
            // jQuery will unbind the event using DOM methods.
            if ( $.support.orientation ) { return false; }

            // Because the orientationchange event doesn't exist, unbind the
            // resize event handler.
            win.unbind( "resize", handler );
        },
        add: function( handleObj ) {
            // Save a reference to the bound event handler.
            var old_handler = handleObj.handler;

            handleObj.handler = function( event ) {
                // Modify event object, adding the .orientation property.
                event.orientation = get_orientation();

                // Call the originally-bound event handler and return its result.
                return old_handler.apply( this, arguments );
            };
        }
    };

    // If the event is not supported natively, this handler will be bound to
    // the window resize event to simulate the orientationchange event.
    function handler() {
        // Get the current orientation.
        var orientation = get_orientation();

        if ( orientation !== last_orientation ) {
            // The orientation has changed, so trigger the orientationchange event.
            last_orientation = orientation;
            win.trigger( "orientationchange" );
        }
    };

    // Get the current page orientation. This method is exposed publicly, should it
    // be needed, as jQuery.event.special.orientationchange.orientation()
    special_event.orientation = get_orientation = function() {
        var elem = document.documentElement;
        return elem && elem.clientWidth / elem.clientHeight < 1.1 ? "portrait" : "landscape";
    };

    })(jQuery);

    $.each({
    scrollstop: "scrollstart",
    taphold: "tap",
    swipeleft: "swipe",
    swiperight: "swipe"
    }, function( event, sourceEvent ) {
    $.event.special[ event ] = {
        setup: function() {
            $( this ).bind( sourceEvent, $.noop );
        }
    };
    });

})( jQuery );

/*!
 * jQuery UI Widget 1.8.24
 *
 * Copyright 2012, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Widget
 */
(function( $, undefined ) {

// jQuery 1.4+
if ( $.cleanData ) {
	var _cleanData = $.cleanData;
	$.cleanData = function( elems ) {
		for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
			try {
				$( elem ).triggerHandler( "remove" );
			// http://bugs.jquery.com/ticket/8235
			} catch( e ) {}
		}
		_cleanData( elems );
	};
} else {
	var _remove = $.fn.remove;
	$.fn.remove = function( selector, keepData ) {
		return this.each(function() {
			if ( !keepData ) {
				if ( !selector || $.filter( selector, [ this ] ).length ) {
					$( "*", this ).add( [ this ] ).each(function() {
						try {
							$( this ).triggerHandler( "remove" );
						// http://bugs.jquery.com/ticket/8235
						} catch( e ) {}
					});
				}
			}
			return _remove.call( $(this), selector, keepData );
		});
	};
}

$.widget = function( name, base, prototype ) {
	var namespace = name.split( "." )[ 0 ],
		fullName;
	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName ] = function( elem ) {
		return !!$.data( elem, name );
	};

	$[ namespace ] = $[ namespace ] || {};
	$[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without initializing for simple inheritance
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	var basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
//	$.each( basePrototype, function( key, val ) {
//		if ( $.isPlainObject(val) ) {
//			basePrototype[ key ] = $.extend( {}, val );
//		}
//	});
	basePrototype.options = $.extend( true, {}, basePrototype.options );
	$[ namespace ][ name ].prototype = $.extend( true, basePrototype, {
		namespace: namespace,
		widgetName: name,
		widgetEventPrefix: $[ namespace ][ name ].prototype.widgetEventPrefix || name,
		widgetBaseClass: fullName
	}, prototype );

	$.widget.bridge( name, $[ namespace ][ name ] );
};

$.widget.bridge = function( name, object ) {
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = Array.prototype.slice.call( arguments, 1 ),
			returnValue = this;

		// allow multiple hashes to be passed on init
		options = !isMethodCall && args.length ?
			$.extend.apply( null, [ true, options ].concat(args) ) :
			options;

		// prevent calls to internal methods
		if ( isMethodCall && options.charAt( 0 ) === "_" ) {
			return returnValue;
		}

		if ( isMethodCall ) {
			this.each(function() {
				var instance = $.data( this, name ),
					methodValue = instance && $.isFunction( instance[options] ) ?
						instance[ options ].apply( instance, args ) :
						instance;
				// TODO: add this back in 1.9 and use $.error() (see #5972)
//				if ( !instance ) {
//					throw "cannot call methods on " + name + " prior to initialization; " +
//						"attempted to call method '" + options + "'";
//				}
//				if ( !$.isFunction( instance[options] ) ) {
//					throw "no such method '" + options + "' for " + name + " widget instance";
//				}
//				var methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue;
					return false;
				}
			});
		} else {
			this.each(function() {
				var instance = $.data( this, name );
				if ( instance ) {
					instance.option( options || {} )._init();
				} else {
					$.data( this, name, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( options, element ) {
	// allow instantiation without initializing for simple inheritance
	if ( arguments.length ) {
		this._createWidget( options, element );
	}
};

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	options: {
		disabled: false
	},
	_createWidget: function( options, element ) {
		// $.widget.bridge stores the plugin instance, but we do it anyway
		// so that it's stored even before the _create function runs
		$.data( element, this.widgetName, this );
		this.element = $( element );
		this.options = $.extend( true, {},
			this.options,
			this._getCreateOptions(),
			options );

		var self = this;
		this.element.bind( "remove." + this.widgetName, function() {
			self.destroy();
		});

		this._create();
		this._trigger( "create" );
		this._init();
	},
	_getCreateOptions: function() {
		return $.metadata && $.metadata.get( this.element[0] )[ this.widgetName ];
	},
	_create: function() {},
	_init: function() {},

	destroy: function() {
		this.element
			.unbind( "." + this.widgetName )
			.removeData( this.widgetName );
		this.widget()
			.unbind( "." + this.widgetName )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetBaseClass + "-disabled " +
				"ui-state-disabled" );
	},

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.extend( {}, this.options );
		}

		if  (typeof key === "string" ) {
			if ( value === undefined ) {
				return this.options[ key ];
			}
			options = {};
			options[ key ] = value;
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var self = this;
		$.each( options, function( key, value ) {
			self._setOption( key, value );
		});

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				[ value ? "addClass" : "removeClass"](
					this.widgetBaseClass + "-disabled" + " " +
					"ui-state-disabled" )
				.attr( "aria-disabled", value );
		}

		return this;
	},

	enable: function() {
		return this._setOption( "disabled", false );
	},
	disable: function() {
		return this._setOption( "disabled", true );
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );

		return !( $.isFunction(callback) &&
			callback.call( this.element[0], event, data ) === false ||
			event.isDefaultPrevented() );
	}
};

})( jQuery );

/*
 * Copyright 2014 D3R Ltd
 * http://d3r.com
 *
 * D3R Standard Javascript
 *
 * You'll want at least:

    .js .d3r-show,
    .js .d3r-hide {
        cursor: pointer;
    }
    .js .d3r-hidden {
        display: none;
    }
    .js .d3r-shown {
        display: block;
    }
    .d3r-chooser {

    }
        .d3r-chooser-option,
        .d3r-multichooser-option {
            display: none;
        }
 *
 */

// hidey showey
$(document).on('click', '.d3r-show, .d3r-hide', function(e) {
    var $this = $(this),
        $target;
    if ($this.is('a')) e.preventDefault();
    if (!!$this.data('target')) {
        $target = $('#'+$this.data('target'));
    } else if (!!$this.attr('href') && "#" == $this.attr('href')[0]) {
        $target = $($this.attr('href'));
    }
    if ($target.length) {
        var hide = $this.hasClass('d3r-hide');
        $target[hide ? 'toggleClass' : 'addClass']('d3r-shown');
        $this[hide ? 'toggleClass' : 'addClass']('d3r-active');
    }
    if ($target.hasClass('d3r-shown') && $this.hasClass('d3r-autoclose')) {
        var autoclose = function(e) {
            if (!$.contains($target[0], e.target)) {
                if ($target.hasClass('d3r-shown')) {
                    e.preventDefault();
                    $target.removeClass('d3r-shown');
                    $this.removeClass('d3r-active');
                }
                $(document).off('click', autoclose);
            }
        };
        $(document).on('click', autoclose);
    }
});
// redirect from dropdowns
$(document).on('change', 'select.d3r-redirector', function(e) {
    window.location.assign($(this).val());
});
// display things based on dropdowns
$(document).on('change', 'select.d3r-chooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-chooser-option').filter('[data-chooser="'+$this.attr('id')+'"]');
    $options.removeClass('d3r-shown');

    var selectors = ['[data-chooservalue="' + $this.val() + '"]'];

    if ($this.val()) {
        selectors.push('#' + $this.val());
    }

    $options.filter(selectors.join(',')).addClass('d3r-shown');
});
$(document).on('change', 'select.d3r-multichooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-multichooser-option').filter('[data-multichooser="'+$this.attr('id')+'"]'),
        $option = $('option:selected', this);
    $options.removeClass('d3r-shown');
    $.each($option.data('values').split(' '), function(index, val) {
        var selectors = ['[data-chooservalue="' + val + '"]'];

        if (val) {
            selectors.push('#' + val);
        }

        $options.filter(selectors.join(',')).addClass('d3r-shown');
    });
});
$(document).on('change', 'input[type="radio"].d3r-chooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-chooser-option').filter('[data-chooser="'+$this.attr('name')+'"]');
    $options.removeClass('d3r-shown');

    if ($this.is(':checked')) {
        var selectors = ['[data-chooservalue="' + $this.val() + '"]'];

        if ($this.val()) {
            selectors.push('#' + $this.val());
        }

        $options.filter(selectors.join(',')).addClass('d3r-shown');
    }
});

$('input[type="radio"].d3r-chooser:checked').trigger('change');

$(document).on('click', '.d3r-submit', function(e) {
    var $this = $(this);

    // If the form is invalid, don't disable the button.
    if ($this.closest('form') &&
        !$this.closest('form')[0].checkValidity()) {
        return;
    }
    // The timeout is to allow this submission to proceed. Nasty I know, sorry.
    if ($this.hasClass('d3r-disabled')) {
        e.preventDefault();
    }
    $this.addClass('d3r-disabled');
    if (!$this.is('a')) {
        setTimeout(function() {
            $this.prop('disabled', true);
        }, 0);
    }
});
$(document).on('click', '.d3r-confirm', function(e) {
    var $this = $(this),
        message = 'Are you sure?';
    if (!!$this.data('confirm')) message = $this.data('confirm');
    if (!window.confirm(message)) e.preventDefault();
});
$(document).on('click', '.d3r-scrollto', function(e) {
    var $this = $(this),
        $target;
    if (!!$this.data('target')) {
        $target = $('#'+$this.data('target'));
    } else if (!!$this.attr('href') && "#" == $this.attr('href').replace(window.location.pathname,"")[0]) {
        $target = $($this.attr('href').replace(window.location.pathname,""));
    }
    if ($target.length) {
        var hash = $target.attr("id");
        $target.removeAttr("id");
        $("html,body").animate({
            scrollTop: $target.offset().top
        }, 500, function() {
            $target.attr("id", hash);
        });
    }
});
$(document).on('click', '.d3r-popup', function(e) {
    e.preventDefault();
    var $this = $(this),
        url = $this.attr('href'),
        width = 600,
        height = 300,
        target = 'popup';
    if (!!$this.data('width')) width = $this.data('width');
    if (!!$this.data('height')) height = $this.data('height');
    if (!!$this.attr('target')) target = $this.attr('target');

    var newwindow = window.open(url, target ,'height='+height+',width='+width);
    if (window.focus) newwindow.focus();
});

/**
 * Copyright D3R 2013
 * http://d3r.com
 * dom@d3r.com
 *
 * Dependencies: jQuery, jquery.widget.js, jquery.mobile.events.js
 */
(function($) {
    var slider = {
        options: {
            item            : ".grid > *",
            page            : false,
            wrapper         : ".grid",
            next            : ".slider__next",
            prev            : ".slider__prev",
            count           : ".slider__count",
            index           : ".slider__index",
            nav             : ".slider__nav",
            navItem         : ".slider__nav__item",
            navActiveClass  : "slider__nav__item--active",
            autoplay        : false,
            autostop        : false,
            autodelay       : 5000,
            equalHeights    : false,
            debug           : false,
            removeClasses   : false,
            disableSelect   : true,
            onInitCallback  : $.noop,
            onSelectCallback: $.noop
        },
        _init: function() {
            var widget = this;
            this._debug('Slider :: INIT');

            this.slides = $(this.options.item, this.element);
            this._debug(this.slides);
            if (!!this.options.page) {
                this.itemsPerPage = 0;
                this.wrapper = $(this.options.wrapper, this.element);
                this._setupPages();
            }

            if (this.slides.length > 1) {
                this.element.addClass('slider--enabled');

                this.slides.addClass('slider__slide');

                this._debug('Slider :: INIT', this.slides);

                var prevent = ['dragstart'];

                if (this.options.disableSelect) {
                    prevent.push('selectstart');
                }

                $(this.element).bind(prevent.join(' '), function(e) {
                    e.preventDefault();
                });

                var active = this.slides.filter('.slider__slide--active');

                if (active.length) {
                    this.active = active.eq(0);
                } else {
                    this.active = this.slides.eq(0).addClass('slider__slide--active');
                }

                this.index = this.slides.index(this.active);

                this.playing = false;

                if (!!this.options.next) {
                    $(this.options.next, this.element).bind('click', $.proxy(this, 'next'));
                }
                if (!!this.options.prev) {
                    $(this.options.prev, this.element).bind('click', $.proxy(this, 'prev'));
                }

                if (!!this.options.nav) {
                    this._initNav();
                    if (!!this.options.count) {
                        $(this.options.count, this.element).text(this.slides.length);
                    }
                    this._updateNav();
                }

                // delay this because we need to wait for font replacement
                if (this.options.equalHeights) {
                    this._updateHeights();
                }

                // Unbind the swipes when not scrolling as jquery mobile doesn;t seem to be capable of not firing them.
                // $(window).bind('scrollstart', $.proxy(this, '_unbindSwipes')).bind('scrollstop', $.proxy(this, '_bindSwipes'));

                this._bindSwipes();

                if (this.options.autoplay) {
                    this.play();
                    this.element.mouseleave($.proxy(this, 'play'));
                    if (this.options.autostop) {
                        this.element.mouseenter($.proxy(this, 'stop'));
                    }
                }

                $(window).on('blur', function(e) {
                    if (widget.playing) {
                        $(window).on('blur', $.proxy(this, 'play'));
                    }
                    $.proxy(this, 'stop');
                });

                widget.options.onInitCallback();
            }
        },
        destroy: function() {
            this._debug('Slider :: DESTROY');

            if (this.options.removeClasses) {
                this.element.removeClass('slider--enabled');
                this.slides.removeClass(function(index, classnames) {
                    return (classnames.match (/\bslider\S+/g) || []).join(' ');
                });
            }

            this._unbindSwipes();

            $(this.options.next, this.element).unbind('click', $.proxy(this, 'next'));
            $(this.options.prev, this.element).unbind('click', $.proxy(this, 'prev'));
        },
        select: function(index, diff) {
            this._debug('Slider :: SELECT', index);
            if (this.slides.length <= index || this.index === index) return;

            if (!diff) diff = index - this.index;

            var widget = this,
                next = this.slides.eq(index),
                exitClass,
                enterClass;

            this._trigger('beforeSlide', null, {index: index, slide: next});

            if (diff >= 0) {
                // from the right
                exitClass = 'slider__slide--exit-left';
                enterClass = 'slider__slide--enter-right';
            } else {
                // from the left
                exitClass = 'slider__slide--exit-right';
                enterClass = 'slider__slide--enter-left';
            }

            widget.slides.removeClass('slider__slide--enter-left slider__slide--enter-right slider__slide--exit-left slider__slide--exit-right');
            next.addClass(enterClass);
            widget.active.addClass(exitClass);

            // Need the classes to be added in a separate moment
            window.setTimeout(function() {
                widget.active.removeClass('slider__slide--active');
                next.addClass('slider__slide--active');
                widget.active = next;
                widget.index = index;
                if (!!widget.options.nav) {
                    widget._updateNav();
                }
                widget._trigger('afterSlide', null, {index: index, slide: next});
                widget.options.onSelectCallback();
            }, 50);
        },
        next: function(e) {
            e.preventDefault();
            this.stop();
            this._next();
        },
        prev: function(e) {
            e.preventDefault();
            this.stop();
            this._prev();
        },
        _next: function() {
            this.select((this.index + 1) % this.slides.length, 1);
        },
        _prev: function() {
            this.select((this.index + this.slides.length - 1) % this.slides.length, -1);
        },
        play: function() {
            this._debug('Slider :: PLAY');
            if (!this.playing) this.playing = setInterval($.proxy(this, '_next'), this.options.autodelay);
        },
        stop: function() {
            this._debug('Slider :: STOP');
            if (this.playing) {
                clearInterval(this.playing);
                this.playing = false;
            }
        },
        _setupPages: function() {
            this._debug('Slider :: SETUP PAGES');
            var count = Math.round(this.wrapper.innerWidth() / this.slides.outerWidth());
            if (count !== this.itemsPerPage && this.itemsPerPage < this.slides.length) {
                var page = $(this.options.page,this.element).first();
                this.itemsPerPage = count;
                var items = this.slides.toArray();
                this.wrapper.empty();
                while (items.length > 0) {
                    this.wrapper.append(page.clone().append(items.splice(0, count)).addClass('slider__slide'));
                }
                this.slides = this.wrapper.children();
                // $(window).bind('resize', $.proxy(this, '_setupPages'));
            }
        },
        _bindSwipes: function() {
            this._debug('Slider :: BIND SWIPES');
            this.slides.bind('swipeleft', $.proxy(this, 'next'));
            this.slides.bind('swiperight', $.proxy(this, 'prev'));
        },
        _unbindSwipes: function() {
            this._debug('Slider :: UNBIND SWIPES');
            this.slides.unbind('swipeleft', $.proxy(this, 'next'));
            this.slides.unbind('swiperight', $.proxy(this, 'prev'));
        },
        _initNav: function() {
            this._debug('Slider :: INIT NAV');
            var widget = this;
            if (!!this.options.nav) {
                this.nav = $(this.options.nav, this.element);
                this.navItems = $(widget.options.navItem, this.nav);
                this.nav.on('click', widget.options.navItem, function(e) {
                    e.preventDefault();
                    var index = $(this).index();
                    if (index !== widget.index) {
                        widget.stop();
                        widget.select(index);
                    }
                });
            }
        },
        _updateNav: function() {
            if (!!this.options.index) {
                $(this.options.index, this.element).text(this.index + 1);
            }
            if (!!this.options.nav) {
                this.navItems.removeClass(this.options.navActiveClass);
                this.navItems.eq(this.index).addClass(this.options.navActiveClass);
            }
        },
        _updateHeights: function() {
            this._debug('Slider :: UPDATE HEIGHTS', this.element.height());
            this.slides.css('height', 'auto');
            this.slides.css('height', this.element.innerHeight());
        },
        _debug: function() {
            if (true === this.options.debug && !!window.console && !!window.console.log){
                window.console.log.apply(window.console, arguments);
            }
        }
    };
    $.widget('d3r.slider', slider);
})(jQuery);

/**
 * Copyright D3R 2013
 * http://d3r.com
 * dom@d3r.com
 *
 * Dependencies: jQuery, jquery.widget.js, jquery.mobile.events.js
 */
(function($) {
    var scrollable = {
        options: {
            track            : ".scrollable__track",
            slide            : ".scrollable__slide",
            next            : ".scrollable__next",
            prev            : ".scrollable__prev",
            count           : ".scrollable__count",
            index           : ".scrollable__index",
            nav             : ".scrollable__nav",
            navItem         : ".scrollable__nav__item",
            navActiveClass  : "scrollable__nav__item--active",
            disabledClass   : "scrollable--disabled",
            activeClass     : "scrollable__slide--active",
            hiddenClass     : "scrollable__slide--hidden",
            paginate        : false,
            autorefresh     : true,
            autoplay        : false,
            autostop        : false,
            autodelay       : 5000,
            debug           : false,
            beforeSlide     : false,
            afterSlide      : false
        },
        _init: function() {
            this._debug('Scrollable :: INIT');

            var widget = this;

            this.slides = $(this.options.slide, this.element);
            this.track = $(this.options.track, this.element);

            this._debug(this.slides);

            if (!!this.options.page) {
                this.itemsPerPage = 0;
                this.wrapper = $(this.options.wrapper, this.element);
                this._setupPages();
            }

            if (this.slides.length > 1) {

                this._debug('Scrollable :: INIT', this.slides);

                $(this.element).bind('dragstart selectstart', function(e) {
                    e.preventDefault();
                });

                this.active = this.slides.eq(0);

                this.index = this.slides.index(this.active);

                if (this.options.paginate) {
                    this.perPage = Math.round(this.track.outerWidth() / this.active.outerWidth());
                }

                this.playing = false;

                if (!!this.options.next) {
                    this.nextButton = $(this.options.next, this.element).on('click', $.proxy(this, 'next'));
                }
                if (!!this.options.prev) {
                    this.prevButton = $(this.options.prev, this.element).on('click', $.proxy(this, 'prev'));
                }

                if (!!this.options.nav) {
                    this._initNav();
                    if (!!this.options.count) {
                        $(this.options.count, this.element).text(this.slides.length);
                    }
                    this._updateNav();
                }

                if (this.options.autorefresh) {
                    $(window).resize($.proxy(this, 'refresh'));
                }

                // Unbind the swipes when not scrolling as jquery mobile doesn;t seem to be capable of not firing them.
                // $(window).bind('scrollstart', $.proxy(this, '_unbindSwipes')).bind('scrollstop', $.proxy(this, '_bindSwipes'));

                this._bindSwipes();
                this._updatePages();
                this._updateButtons();
                this._updateHidden();
                this._updateActive();

                if (this.options.autoplay) {
                    this.play();
                    this.element.mouseleave($.proxy(this, 'play'));
                    if (this.options.autostop) {
                        this.element.mouseenter($.proxy(this, 'stop'));
                    }
                }

                // This is a hack to disable transitions of elements on page load
                window.setTimeout(function() {
                    widget.element.addClass('scrollable--enabled');
                }, 1);
            }
        },
        destroy: function() {
            this._debug('Scrollable :: DESTROY');

            if (!!this.options.next) {
                $(this.options.next, this.element).off('click', $.proxy(this, 'next'));
            }
            if (!!this.options.prev) {
                $(this.options.prev, this.element).off('click', $.proxy(this, 'prev'));
            }
            if (this.options.autorefresh) {
                $(window).off('resize', $.proxy(this, 'refresh'));
            }
        },
        select: function(index) {
            this._debug('Scrollable :: SELECT', index);
            if (!this._indexIsValid(index)) return;
            // this._trigger('beforeSlide', null, {index: index, slide: next});

            this.active = this.slides.eq(index);
            this.index = index;
            var widget = this;

            $.when($.isFunction(this.options.beforeSlide) && this.options.beforeSlide.call(widget)).done(function() {
                widget.refresh();
                widget._updateNav();
                widget._updateHidden();
                widget._updateActive();
                if ($.isFunction(widget.options.afterSlide)) {
                    widget.options.afterSlide.call(widget)
                }
                if (widget.options.autoplay) {
                    widget.play();
                }
            });
        },
        refresh: function() {
            this._debug('Scrollable :: REFRESH');
            var multiplier = this.active.outerWidth() / this.track.outerWidth();
            this.track.css({
                transform: "translateX(-" + (this.index * 100 * multiplier) + "%)"
            });
            this._updatePages();
            this._updateButtons();
        },
        next: function(e) {
            if (!!e) e.preventDefault();
            this.stop();
            this.select(this._nextIndex());
        },
        _nextOrStart: function() {
            if (this._indexIsValid(this._nextIndex())) {
                this.next();
            } else {
                this.select(0);
            }
        },
        _nextIndex: function() {
            var index = this.index + 1;
            if (this.options.paginate) {
                index = this.index + this.itemsPerPage;
            }
            return index;
        },
        prev: function(e) {
            if (!!e) e.preventDefault();
            this.stop();
            this.select(this._prevIndex());
        },
        _prevIndex: function() {
            var index = this.index - 1;
            if (this.options.paginate) {
                index = this.index - this.itemsPerPage;

                if (index > 0 && index < this.itemsPerPage) {
                    index = 0;
                }
                if (index >= this.slides.length) {
                    index = this.slides.length - 1;
                }
            } else if (index > this.slides.length - this.itemsPerPage) {
                index = this.slides.length - this.itemsPerPage;
            }
            return index;
        },
        play: function() {
            this._debug('Scrollable :: PLAY');
            if (!this.playing) this.playing = setInterval($.proxy(this, '_nextOrStart'), this.options.autodelay);
        },
        stop: function() {
            this._debug('Scrollable :: STOP');
            if (this.playing) {
                clearInterval(this.playing);
                this.playing = false;
            }
        },
        _updatePages: function() {
            this._debug('Scrollable :: UPDATE PAGES');
            this.itemsPerPage = Math.round(this.track.innerWidth() / this.slides.outerWidth());
        },
        _updateHidden: function() {
            this.slides.removeClass(this.options.hiddenClass);
            if (this.index > 0) {
                this.slides.slice(0, this.index).addClass(this.options.hiddenClass);
            }
            this.slides.slice(this.index + this.itemsPerPage).addClass(this.options.hiddenClass);
        },
        _updateActive: function() {
            this.slides.removeClass(this.options.activeClass);
            this.active.addClass(this.options.activeClass);
        },
        _bindSwipes: function() {
            this._debug('Scrollable :: BIND SWIPES');
            this.element.bind('swipeleft', $.proxy(this, 'next'));
            this.element.bind('swiperight', $.proxy(this, 'prev'));
        },
        _unbindSwipes: function() {
            this._debug('Scrollable :: UNBIND SWIPES');
            this.element.bind('swipeleft', $.proxy(this, 'next'));
            this.element.bind('swiperight', $.proxy(this, 'prev'));
        },
        _updateButtons: function() {
            this.prevButton[this._indexIsValid(this._prevIndex()) ? 'removeClass' : 'addClass'](this.options.disabledClass);
            this.nextButton[this._indexIsValid(this._nextIndex()) ? 'removeClass' : 'addClass'](this.options.disabledClass);
            this.element[
                this._indexIsValid(this._nextIndex()) || this._indexIsValid(this._prevIndex())
                    ? 'removeClass'
                    : 'addClass'
                ]('scrollable--static');
        },
        _indexIsValid: function(index) {
            if (index < 0) return false;
            if (!this.options.paginate) return index <= (this.slides.length - this.itemsPerPage);
            return index + 1 <= this.slides.length;
        },
        _initNav: function() {
            this._debug('Scrollable :: INIT NAV');
            var widget = this;
            if (!!this.options.nav) {
                this.nav = $(this.options.nav, this.element);
                this.navItems = $(widget.options.navItem, this.nav);
                this.nav.on('click', widget.options.navItem, function(e) {
                    e.preventDefault();
                    var index = $(this).index();
                    if (index !== widget.index) {
                        widget.stop();
                        widget.select(index);
                    }
                });
            }
        },
        _updateNav: function() {
            if (!!this.options.index) {
                $(this.options.index, this.element).text(this.index + 1);
            }
            if (!!this.options.nav) {
                this.navItems.removeClass(this.options.navActiveClass);
                this.navItems.eq(this.index).addClass(this.options.navActiveClass);
            }
        },
        // _updateHeights: function() {
        //     this._debug('Scrollable :: UPDATE HEIGHTS', this.element.height());
        //     this.slides.css('height', 'auto');
        //     this.slides.css('height', this.element.innerHeight());
        // },
        _debug: function() {
            if (true === this.options.debug && !!window.console && !!window.console.log){
                window.console.log.apply(window.console, arguments);
            }
        }
    };
    $.widget('d3r.scrollable', scrollable);
})(jQuery);

(function($){
    $.selectreplace = function(el, options){

        var base = this;
        base.$el = $(el);
        base.el = el;

        base.init = function(){

            base.options = $.extend({},$.selectreplace.defaultOptions, options);

            var replace;

            if (base.$el.is('select')) {
                replace = base.$el;
            } else {
                replace = $('select', base.$el);
            }
            replace.wrap(function(index) {
                var $this = $(this);
                if ($this.closest(base.options.wrapper+'.'+base.options.wrapperClass).length === 0) {
                    return $('<'+base.options.wrapper+' class="'+base.options.wrapperClass+'"'+($this.attr('id') ? ' id="'+$this.attr('id')+'_selectreplace"' : '')+'/>')
                    .addClass($this.prop('disabled') ? base.options.wrapperClass+'--disabled' : '');
                }
            }).after(function(index) {
                var $this = $(this);
                if ($this.siblings(base.options.value+'.'+base.options.valueClass).length === 0) {
                    return $('<'+base.options.value+' class="'+base.options.valueClass+'"/>').text($('option[value="'+$this.val()+'"]:first', $this).text());
                }
            }).after(function(index) {
                if (base.options.svgIcon) {
                    return '<svg class="'+base.options.svgIcon+'">\
                        <use xlink:href="'+base.options.svgIconPath+'#'+base.options.svgIcon+'" />\
                    </svg>';
                }
            }).on('change', function(e) {
                var $this = $(this);
                $this.siblings(base.options.value+'.'+base.options.valueClass).text($this.find('option[value="' + $this.val() + '"]:first').text());
            }).on('focus', function() {
                $(this).closest('.'+base.options.wrapperClass).addClass(base.options.wrapperClass+'--focused');
            }).on('blur', function() {
                $(this).closest('.'+base.options.wrapperClass).removeClass(base.options.wrapperClass+'--focused');
            });
        };
        base.init();
    };

    $.selectreplace.defaultOptions = {
        wrapper     : 'div',
        wrapperClass: 'select-wrapper',
        value       : 'p',
        valueClass  : 'value',
        svgIcon     : false,
        svgIconPath : '/images/svg-symbols.svg'
    };

    $.fn.selectreplace = function(value, options){
        return this.each(function(){
            (new $.selectreplace(this, value, options));
        });
    };

})(jQuery);


// Base
// Breakpoints correspond with _breakpoints.scss
var screenSize = {
    breakpoints: {
        phablet: 680
    },
    isSmallerThan: function(breakpoint) {
        if (!screenSize.hasBreakpoint(breakpoint)) {
            return false;
        }
        return $(window).innerWidth() > screenSize.breakpoints[breakpoint];
    },
    isLargerThan: function(breakpoint) {
        if (!screenSize.hasBreakpoint(breakpoint)) {
            return false;
        }
        return $(window).innerWidth() < screenSize.breakpoints[breakpoint];
    },
    hasBreakpoint: function(breakpoint) {
        return screenSize.breakpoints.hasOwnProperty(breakpoint);
    }
};

// Plugins
/**
 * I would do this in CSS but we need to add in the SVG
 * symbol anyway and we only want to show the custom
 * checkbox if this code is run so better to do it here
 *
 * @author Neil Brayfield <neil@d3r.com>
 */
$.fn.checkReplace = function() {
    $(this).each(function() {
        var current = $(this);
        current.wrap('<div class="check-replace"></div>').hide();

        var wrap = $(this).parent();

        wrap.append(
            '<svg class="icon-tick">' +
                '<use xlink:href="/images/svg-symbols.svg#icon-tick" />' +
            '</svg>'
        );

        current.change(function (e) {

            if (current.prop('checked')) {
                wrap.addClass('check-replace--active');
            } else {
                wrap.removeClass('check-replace--active');
            }

            return true;
        });

        $(this).trigger('change');
    });
};

$.fn.radioReplace = function() {
    $(this).each(function() {
        var current = $(this);

        if (current.parent().hasClass('radio-replace') || current.parent().hasClass('radio-replace-alt') || current.attr('data-no-replace')) {
            return;
        }

        current.wrap('<div class="radio-replace-alt"></div>').hide();

        var wrap = $(this).parent();

        current.change(function (e) {
            $('input[type=radio][name="' + $(this).attr('name') + '"]').each(function() {
                $(this).parent().removeClass('radio-replace-alt--active');
            });

            if (current.prop('checked')) {
                wrap.addClass('radio-replace-alt--active');
            }

            return true;
        });

        $(this).trigger('change');

        // Trigger the initial state
        $('input[type=radio][name="' + $(this).attr('name') + '"][checked]').trigger('change');
    });
};

(function (app) {
    app.plugins = app.plugins || {};

    app.plugins.delegate = function delegate(
        element,
        eventType,
        selector,
        listener,
        options
    ) {
        element.addEventListener(
            eventType,
            /**
             * @param {Event} event
             */
            function callback(event) {
                if (event.target instanceof HTMLElement || event.target instanceof SVGElement) {
                    var closest = event.target.closest(selector);
                    if (closest) {
                        listener(event);
                    }
                }
            },
            options || null
        );
    };
})(window.Bespoke = window.Bespoke || {});

!function(root, factory) {
    "function" == typeof define && define.amd ? // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return root.svg4everybody = factory();
    }) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});
/*! Magnific Popup - v1.2.0 - 2024-06-08
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2024 Dmytro Semenov; */
;(function (factory) { 
if (typeof define === 'function' && define.amd) { 
 // AMD. Register as an anonymous module. 
 define(['jquery'], factory); 
 } else if (typeof exports === 'object') { 
 // Node/CommonJS 
 factory(require('jquery')); 
 } else { 
 // Browser globals 
 factory(window.jQuery || window.Zepto); 
 } 
 }(function($) { 

/*>>core*/
/**
 * 
 * Magnific Popup Core JS file
 * 
 */


/**
 * Private static constants
 */
var CLOSE_EVENT = 'Close',
	BEFORE_CLOSE_EVENT = 'BeforeClose',
	AFTER_CLOSE_EVENT = 'AfterClose',
	BEFORE_APPEND_EVENT = 'BeforeAppend',
	MARKUP_PARSE_EVENT = 'MarkupParse',
	OPEN_EVENT = 'Open',
	CHANGE_EVENT = 'Change',
	NS = 'mfp',
	EVENT_NS = '.' + NS,
	READY_CLASS = 'mfp-ready',
	REMOVING_CLASS = 'mfp-removing',
	PREVENT_CLOSE_CLASS = 'mfp-prevent-close';


/**
 * Private vars 
 */
/*jshint -W079 */
var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
	MagnificPopup = function(){},
	_isJQ = !!(window.jQuery),
	_prevStatus,
	_window = $(window),
	_document,
	_prevContentType,
	_wrapClasses,
	_currPopupType;


/**
 * Private functions
 */
var _mfpOn = function(name, f) {
		mfp.ev.on(NS + name + EVENT_NS, f);
	},
	_getEl = function(className, appendTo, html, raw) {
		var el = document.createElement('div');
		el.className = 'mfp-'+className;
		if(html) {
			el.innerHTML = html;
		}
		if(!raw) {
			el = $(el);
			if(appendTo) {
				el.appendTo(appendTo);
			}
		} else if(appendTo) {
			appendTo.appendChild(el);
		}
		return el;
	},
	_mfpTrigger = function(e, data) {
		mfp.ev.triggerHandler(NS + e, data);

		if(mfp.st.callbacks) {
			// converts "mfpEventName" to "eventName" callback and triggers it if it's present
			e = e.charAt(0).toLowerCase() + e.slice(1);
			if(mfp.st.callbacks[e]) {
				mfp.st.callbacks[e].apply(mfp, Array.isArray(data) ? data : [data]);
			}
		}
	},
	_getCloseBtn = function(type) {
		if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
			mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
			_currPopupType = type;
		}
		return mfp.currTemplate.closeBtn;
	},
	// Initialize Magnific Popup only when called at least once
	_checkInstance = function() {
		if(!$.magnificPopup.instance) {
			/*jshint -W020 */
			mfp = new MagnificPopup();
			mfp.init();
			$.magnificPopup.instance = mfp;
		}
	},
	// CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
	supportsTransitions = function() {
		var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
			v = ['ms','O','Moz','Webkit']; // 'v' for vendor

		if( s['transition'] !== undefined ) {
			return true; 
		}
			
		while( v.length ) {
			if( v.pop() + 'Transition' in s ) {
				return true;
			}
		}
				
		return false;
	};



/**
 * Public functions
 */
MagnificPopup.prototype = {

	constructor: MagnificPopup,

	/**
	 * Initializes Magnific Popup plugin. 
	 * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
	 */
	init: function() {
		var appVersion = navigator.appVersion;
		mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
		mfp.isAndroid = (/android/gi).test(appVersion);
		mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
		mfp.supportsTransition = supportsTransitions();

		// We disable fixed positioned lightbox on devices that don't handle it nicely.
		// If you know a better way of detecting this - let me know.
		mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
		_document = $(document);

		mfp.popupsCache = {};
	},

	/**
	 * Opens popup
	 * @param  data [description]
	 */
	open: function(data) {

		var i;

		if(data.isObj === false) { 
			// convert jQuery collection to array to avoid conflicts later
			mfp.items = data.items.toArray();

			mfp.index = 0;
			var items = data.items,
				item;
			for(i = 0; i < items.length; i++) {
				item = items[i];
				if(item.parsed) {
					item = item.el[0];
				}
				if(item === data.el[0]) {
					mfp.index = i;
					break;
				}
			}
		} else {
			mfp.items = Array.isArray(data.items) ? data.items : [data.items];
			mfp.index = data.index || 0;
		}

		// if popup is already opened - we just update the content
		if(mfp.isOpen) {
			mfp.updateItemHTML();
			return;
		}
		
		mfp.types = []; 
		_wrapClasses = '';
		if(data.mainEl && data.mainEl.length) {
			mfp.ev = data.mainEl.eq(0);
		} else {
			mfp.ev = _document;
		}

		if(data.key) {
			if(!mfp.popupsCache[data.key]) {
				mfp.popupsCache[data.key] = {};
			}
			mfp.currTemplate = mfp.popupsCache[data.key];
		} else {
			mfp.currTemplate = {};
		}



		mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data ); 
		mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;

		if(mfp.st.modal) {
			mfp.st.closeOnContentClick = false;
			mfp.st.closeOnBgClick = false;
			mfp.st.showCloseBtn = false;
			mfp.st.enableEscapeKey = false;
		}
		

		// Building markup
		// main containers are created only once
		if(!mfp.bgOverlay) {

			// Dark overlay
			mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
				mfp.close();
			});

			mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
				if(mfp._checkIfClose(e.target)) {
					mfp.close();
				}
			});

			mfp.container = _getEl('container', mfp.wrap);
		}

		mfp.contentContainer = _getEl('content');
		if(mfp.st.preloader) {
			mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
		}


		// Initializing modules
		var modules = $.magnificPopup.modules;
		for(i = 0; i < modules.length; i++) {
			var n = modules[i];
			n = n.charAt(0).toUpperCase() + n.slice(1);
			mfp['init'+n].call(mfp);
		}
		_mfpTrigger('BeforeOpen');


		if(mfp.st.showCloseBtn) {
			// Close button
			if(!mfp.st.closeBtnInside) {
				mfp.wrap.append( _getCloseBtn() );
			} else {
				_mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
					values.close_replaceWith = _getCloseBtn(item.type);
				});
				_wrapClasses += ' mfp-close-btn-in';
			}
		}

		if(mfp.st.alignTop) {
			_wrapClasses += ' mfp-align-top';
		}

	

		if(mfp.fixedContentPos) {
			mfp.wrap.css({
				overflow: mfp.st.overflowY,
				overflowX: 'hidden',
				overflowY: mfp.st.overflowY
			});
		} else {
			mfp.wrap.css({ 
				top: _window.scrollTop(),
				position: 'absolute'
			});
		}
		if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
			mfp.bgOverlay.css({
				height: _document.height(),
				position: 'absolute'
			});
		}

		

		if(mfp.st.enableEscapeKey) {
			// Close on ESC key
			_document.on('keyup' + EVENT_NS, function(e) {
				if(e.keyCode === 27) {
					mfp.close();
				}
			});
		}

		_window.on('resize' + EVENT_NS, function() {
			mfp.updateSize();
		});


		if(!mfp.st.closeOnContentClick) {
			_wrapClasses += ' mfp-auto-cursor';
		}
		
		if(_wrapClasses)
			mfp.wrap.addClass(_wrapClasses);


		// this triggers recalculation of layout, so we get it once to not to trigger twice
		var windowHeight = mfp.wH = _window.height();

		
		var windowStyles = {};

		if( mfp.fixedContentPos ) {
            if(mfp._hasScrollBar(windowHeight)){
                var s = mfp._getScrollbarSize();
                if(s) {
                    windowStyles.marginRight = s;
                }
            }
        }

		if(mfp.fixedContentPos) {
			if(!mfp.isIE7) {
				windowStyles.overflow = 'hidden';
			} else {
				// ie7 double-scroll bug
				$('body, html').css('overflow', 'hidden');
			}
		}

		
		
		var classesToadd = mfp.st.mainClass;
		if(mfp.isIE7) {
			classesToadd += ' mfp-ie7';
		}
		if(classesToadd) {
			mfp._addClassToMFP( classesToadd );
		}

		// add content
		mfp.updateItemHTML();

		_mfpTrigger('BuildControls');

		// remove scrollbar, add margin e.t.c
		$('html').css(windowStyles);
		
		// add everything to DOM
		mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || $(document.body) );

		// Save last focused element
		mfp._lastFocusedEl = document.activeElement;
		
		// Wait for next cycle to allow CSS transition
		setTimeout(function() {
			
			if(mfp.content) {
				mfp._addClassToMFP(READY_CLASS);
				mfp._setFocus();
			} else {
				// if content is not defined (not loaded e.t.c) we add class only for BG
				mfp.bgOverlay.addClass(READY_CLASS);
			}
			
			// Trap the focus in popup
			_document.on('focusin' + EVENT_NS, mfp._onFocusIn);

		}, 16);

		mfp.isOpen = true;
		mfp.updateSize(windowHeight);
		_mfpTrigger(OPEN_EVENT);

		return data;
	},

	/**
	 * Closes the popup
	 */
	close: function() {
		if(!mfp.isOpen) return;
		_mfpTrigger(BEFORE_CLOSE_EVENT);

		mfp.isOpen = false;
		// for CSS3 animation
		if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
			mfp._addClassToMFP(REMOVING_CLASS);
			setTimeout(function() {
				mfp._close();
			}, mfp.st.removalDelay);
		} else {
			mfp._close();
		}
	},

	/**
	 * Helper for close() function
	 */
	_close: function() {
		_mfpTrigger(CLOSE_EVENT);

		var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';

		mfp.bgOverlay.detach();
		mfp.wrap.detach();
		mfp.container.empty();

		if(mfp.st.mainClass) {
			classesToRemove += mfp.st.mainClass + ' ';
		}

		mfp._removeClassFromMFP(classesToRemove);

		if(mfp.fixedContentPos) {
			var windowStyles = {marginRight: ''};
			if(mfp.isIE7) {
				$('body, html').css('overflow', '');
			} else {
				windowStyles.overflow = '';
			}
			$('html').css(windowStyles);
		}
		
		_document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
		mfp.ev.off(EVENT_NS);

		// clean up DOM elements that aren't removed
		mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
		mfp.bgOverlay.attr('class', 'mfp-bg');
		mfp.container.attr('class', 'mfp-container');

		// remove close button from target element
		if(mfp.st.showCloseBtn &&
		(!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
			if(mfp.currTemplate.closeBtn)
				mfp.currTemplate.closeBtn.detach();
		}


		if(mfp.st.autoFocusLast && mfp._lastFocusedEl) {
			$(mfp._lastFocusedEl).trigger('focus'); // put tab focus back
		}
		mfp.currItem = null;	
		mfp.content = null;
		mfp.currTemplate = null;
		mfp.prevHeight = 0;

		_mfpTrigger(AFTER_CLOSE_EVENT);
	},
	
	updateSize: function(winHeight) {

		if(mfp.isIOS) {
			// fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
			var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
			var height = window.innerHeight * zoomLevel;
			mfp.wrap.css('height', height);
			mfp.wH = height;
		} else {
			mfp.wH = winHeight || _window.height();
		}
		// Fixes #84: popup incorrectly positioned with position:relative on body
		if(!mfp.fixedContentPos) {
			mfp.wrap.css('height', mfp.wH);
		}

		_mfpTrigger('Resize');

	},

	/**
	 * Set content of popup based on current index
	 */
	updateItemHTML: function() {
		var item = mfp.items[mfp.index];

		// Detach and perform modifications
		mfp.contentContainer.detach();

		if(mfp.content)
			mfp.content.detach();

		if(!item.parsed) {
			item = mfp.parseEl( mfp.index );
		}

		var type = item.type;

		_mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
		// BeforeChange event works like so:
		// _mfpOn('BeforeChange', function(e, prevType, newType) { });

		mfp.currItem = item;

		if(!mfp.currTemplate[type]) {
			var markup = mfp.st[type] ? mfp.st[type].markup : false;

			// allows to modify markup
			_mfpTrigger('FirstMarkupParse', markup);

			if(markup) {
				mfp.currTemplate[type] = $(markup);
			} else {
				// if there is no markup found we just define that template is parsed
				mfp.currTemplate[type] = true;
			}
		}

		if(_prevContentType && _prevContentType !== item.type) {
			mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
		}

		var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
		mfp.appendContent(newContent, type);

		item.preloaded = true;

		_mfpTrigger(CHANGE_EVENT, item);
		_prevContentType = item.type;

		// Append container back after its content changed
		mfp.container.prepend(mfp.contentContainer);

		_mfpTrigger('AfterChange');
	},


	/**
	 * Set HTML content of popup
	 */
	appendContent: function(newContent, type) {
		mfp.content = newContent;

		if(newContent) {
			if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
				mfp.currTemplate[type] === true) {
				// if there is no markup, we just append close button element inside
				if(!mfp.content.find('.mfp-close').length) {
					mfp.content.append(_getCloseBtn());
				}
			} else {
				mfp.content = newContent;
			}
		} else {
			mfp.content = '';
		}

		_mfpTrigger(BEFORE_APPEND_EVENT);
		mfp.container.addClass('mfp-'+type+'-holder');

		mfp.contentContainer.append(mfp.content);
	},


	/**
	 * Creates Magnific Popup data object based on given data
	 * @param  {int} index Index of item to parse
	 */
	parseEl: function(index) {
		var item = mfp.items[index],
			type;

		if(item.tagName) {
			item = { el: $(item) };
		} else {
			type = item.type;
			item = { data: item, src: item.src };
		}

		if(item.el) {
			var types = mfp.types;

			// check for 'mfp-TYPE' class
			for(var i = 0; i < types.length; i++) {
				if( item.el.hasClass('mfp-'+types[i]) ) {
					type = types[i];
					break;
				}
			}

			item.src = item.el.attr('data-mfp-src');
			if(!item.src) {
				item.src = item.el.attr('href');
			}
		}

		item.type = type || mfp.st.type || 'inline';
		item.index = index;
		item.parsed = true;
		mfp.items[index] = item;
		_mfpTrigger('ElementParse', item);

		return mfp.items[index];
	},


	/**
	 * Initializes single popup or a group of popups
	 */
	addGroup: function(el, options) {
		var eHandler = function(e) {
			e.mfpEl = this;
			mfp._openClick(e, el, options);
		};

		if(!options) {
			options = {};
		}

		var eName = 'click.magnificPopup';
		options.mainEl = el;

		if(options.items) {
			options.isObj = true;
			el.off(eName).on(eName, eHandler);
		} else {
			options.isObj = false;
			if(options.delegate) {
				el.off(eName).on(eName, options.delegate , eHandler);
			} else {
				options.items = el;
				el.off(eName).on(eName, eHandler);
			}
		}
	},
	_openClick: function(e, el, options) {
		var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;


		if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey ) ) {
			return;
		}

		var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

		if(disableOn) {
			if(typeof disableOn === "function") {
				if( !disableOn.call(mfp) ) {
					return true;
				}
			} else { // else it's number
				if( _window.width() < disableOn ) {
					return true;
				}
			}
		}

		if(e.type) {
			e.preventDefault();

			// This will prevent popup from closing if element is inside and popup is already opened
			if(mfp.isOpen) {
				e.stopPropagation();
			}
		}

		options.el = $(e.mfpEl);
		if(options.delegate) {
			options.items = el.find(options.delegate);
		}
		mfp.open(options);
	},


	/**
	 * Updates text on preloader
	 */
	updateStatus: function(status, text) {

		if(mfp.preloader) {
			if(_prevStatus !== status) {
				mfp.container.removeClass('mfp-s-'+_prevStatus);
			}

			if(!text && status === 'loading') {
				text = mfp.st.tLoading;
			}

			var data = {
				status: status,
				text: text
			};
			// allows to modify status
			_mfpTrigger('UpdateStatus', data);

			status = data.status;
			text = data.text;

			if (mfp.st.allowHTMLInStatusIndicator) {
				mfp.preloader.html(text);
			} else {
				mfp.preloader.text(text);
			}

			mfp.preloader.find('a').on('click', function(e) {
				e.stopImmediatePropagation();
			});

			mfp.container.addClass('mfp-s-'+status);
			_prevStatus = status;
		}
	},


	/*
		"Private" helpers that aren't private at all
	 */
	// Check to close popup or not
	// "target" is an element that was clicked
	_checkIfClose: function(target) {

		if($(target).closest('.' + PREVENT_CLOSE_CLASS).length) {
			return;
		}

		var closeOnContent = mfp.st.closeOnContentClick;
		var closeOnBg = mfp.st.closeOnBgClick;

		if(closeOnContent && closeOnBg) {
			return true;
		} else {

			// We close the popup if click is on close button or on preloader. Or if there is no content.
			if(!mfp.content || $(target).closest('.mfp-close').length || (mfp.preloader && target === mfp.preloader[0]) ) {
				return true;
			}

			// if click is outside the content
			if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
				if(closeOnBg) {
					// last check, if the clicked element is in DOM, (in case it's removed onclick)
					if( $.contains(document, target) ) {
						return true;
					}
				}
			} else if(closeOnContent) {
				return true;
			}

		}
		return false;
	},
	_addClassToMFP: function(cName) {
		mfp.bgOverlay.addClass(cName);
		mfp.wrap.addClass(cName);
	},
	_removeClassFromMFP: function(cName) {
		this.bgOverlay.removeClass(cName);
		mfp.wrap.removeClass(cName);
	},
	_hasScrollBar: function(winHeight) {
		return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
	},
	_setFocus: function() {
		(mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).trigger('focus');
	},
	_onFocusIn: function(e) {
		if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
			mfp._setFocus();
			return false;
		}
	},
	_parseMarkup: function(template, values, item) {
		var arr;
		if(item.data) {
			values = $.extend(item.data, values);
		}
		_mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );

		$.each(values, function(key, value) {
			if(value === undefined || value === false) {
				return true;
			}
			arr = key.split('_');
			if(arr.length > 1) {
				var el = template.find(EVENT_NS + '-'+arr[0]);

				if(el.length > 0) {
					var attr = arr[1];
					if(attr === 'replaceWith') {
						if(el[0] !== value[0]) {
							el.replaceWith(value);
						}
					} else if(attr === 'img') {
						if(el.is('img')) {
							el.attr('src', value);
						} else {
							el.replaceWith( $('<img>').attr('src', value).attr('class', el.attr('class')) );
						}
					} else {
						el.attr(arr[1], value);
					}
				}

			} else {
				if (mfp.st.allowHTMLInTemplate) {
					template.find(EVENT_NS + '-'+key).html(value);
				} else {
					template.find(EVENT_NS + '-'+key).text(value);
				}
			}
		});
	},

	_getScrollbarSize: function() {
		// thx David
		if(mfp.scrollbarSize === undefined) {
			var scrollDiv = document.createElement("div");
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return mfp.scrollbarSize;
	}

}; /* MagnificPopup core prototype end */




/**
 * Public static functions
 */
$.magnificPopup = {
	instance: null,
	proto: MagnificPopup.prototype,
	modules: [],

	open: function(options, index) {
		_checkInstance();

		if(!options) {
			options = {};
		} else {
			options = $.extend(true, {}, options);
		}

		options.isObj = true;
		options.index = index || 0;
		return this.instance.open(options);
	},

	close: function() {
		return $.magnificPopup.instance && $.magnificPopup.instance.close();
	},

	registerModule: function(name, module) {
		if(module.options) {
			$.magnificPopup.defaults[name] = module.options;
		}
		$.extend(this.proto, module.proto);
		this.modules.push(name);
	},

	defaults: {

		// Info about options is in docs:
		// http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

		disableOn: 0,

		key: null,

		midClick: false,

		mainClass: '',

		preloader: true,

		focus: '', // CSS selector of input to focus after popup is opened

		closeOnContentClick: false,

		closeOnBgClick: true,

		closeBtnInside: true,

		showCloseBtn: true,

		enableEscapeKey: true,

		modal: false,

		alignTop: false,

		removalDelay: 0,

		prependTo: null,

		fixedContentPos: 'auto',

		fixedBgPos: 'auto',

		overflowY: 'auto',

		closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',

		tClose: 'Close (Esc)',

		tLoading: 'Loading...',

		autoFocusLast: true,

		allowHTMLInStatusIndicator: false,

		allowHTMLInTemplate: false

	}
};



$.fn.magnificPopup = function(options) {
	_checkInstance();

	var jqEl = $(this);

	// We call some API method of first param is a string
	if (typeof options === "string" ) {

		if(options === 'open') {
			var items,
				itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
				index = parseInt(arguments[1], 10) || 0;

			if(itemOpts.items) {
				items = itemOpts.items[index];
			} else {
				items = jqEl;
				if(itemOpts.delegate) {
					items = items.find(itemOpts.delegate);
				}
				items = items.eq( index );
			}
			mfp._openClick({mfpEl:items}, jqEl, itemOpts);
		} else {
			if(mfp.isOpen)
				mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
		}

	} else {
		// clone options obj
		options = $.extend(true, {}, options);

		/*
		 * As Zepto doesn't support .data() method for objects
		 * and it works only in normal browsers
		 * we assign "options" object directly to the DOM element. FTW!
		 */
		if(_isJQ) {
			jqEl.data('magnificPopup', options);
		} else {
			jqEl[0].magnificPopup = options;
		}

		mfp.addGroup(jqEl, options);

	}
	return jqEl;
};

/*>>core*/

/*>>inline*/

var INLINE_NS = 'inline',
	_hiddenClass,
	_inlinePlaceholder,
	_lastInlineElement,
	_putInlineElementsBack = function() {
		if(_lastInlineElement) {
			_inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
			_lastInlineElement = null;
		}
	};

$.magnificPopup.registerModule(INLINE_NS, {
	options: {
		hiddenClass: 'hide', // will be appended with `mfp-` prefix
		markup: '',
		tNotFound: 'Content not found'
	},
	proto: {

		initInline: function() {
			mfp.types.push(INLINE_NS);

			_mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
				_putInlineElementsBack();
			});
		},

		getInline: function(item, template) {

			_putInlineElementsBack();

			if(item.src) {
				var inlineSt = mfp.st.inline,
					el = $(item.src);

				if(el.length) {

					// If target element has parent - we replace it with placeholder and put it back after popup is closed
					var parent = el[0].parentNode;
					if(parent && parent.tagName) {
						if(!_inlinePlaceholder) {
							_hiddenClass = inlineSt.hiddenClass;
							_inlinePlaceholder = _getEl(_hiddenClass);
							_hiddenClass = 'mfp-'+_hiddenClass;
						}
						// replace target inline element with placeholder
						_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
					}

					mfp.updateStatus('ready');
				} else {
					mfp.updateStatus('error', inlineSt.tNotFound);
					el = $('<div>');
				}

				item.inlineElement = el;
				return el;
			}

			mfp.updateStatus('ready');
			mfp._parseMarkup(template, {}, item);
			return template;
		}
	}
});

/*>>inline*/

/*>>ajax*/
var AJAX_NS = 'ajax',
	_ajaxCur,
	_removeAjaxCursor = function() {
		if(_ajaxCur) {
			$(document.body).removeClass(_ajaxCur);
		}
	},
	_destroyAjaxRequest = function() {
		_removeAjaxCursor();
		if(mfp.req) {
			mfp.req.abort();
		}
	};

$.magnificPopup.registerModule(AJAX_NS, {

	options: {
		settings: null,
		cursor: 'mfp-ajax-cur',
		tError: 'The content could not be loaded.'
	},

	proto: {
		initAjax: function() {
			mfp.types.push(AJAX_NS);
			_ajaxCur = mfp.st.ajax.cursor;

			_mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
			_mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
		},
		getAjax: function(item) {

			if(_ajaxCur) {
				$(document.body).addClass(_ajaxCur);
			}

			mfp.updateStatus('loading');

			var opts = $.extend({
				url: item.src,
				success: function(data, textStatus, jqXHR) {
					var temp = {
						data:data,
						xhr:jqXHR
					};

					_mfpTrigger('ParseAjax', temp);

					mfp.appendContent( $(temp.data), AJAX_NS );

					item.finished = true;

					_removeAjaxCursor();

					mfp._setFocus();

					setTimeout(function() {
						mfp.wrap.addClass(READY_CLASS);
					}, 16);

					mfp.updateStatus('ready');

					_mfpTrigger('AjaxContentAdded');
				},
				error: function() {
					_removeAjaxCursor();
					item.finished = item.loadError = true;
					mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
				}
			}, mfp.st.ajax.settings);

			mfp.req = $.ajax(opts);

			return '';
		}
	}
});

/*>>ajax*/

/*>>image*/
var _imgInterval,
	_getTitle = function(item) {
		if(item.data && item.data.title !== undefined)
			return item.data.title;

		var src = mfp.st.image.titleSrc;

		if(src) {
			if(typeof src === "function") {
				return src.call(mfp, item);
			} else if(item.el) {
				return item.el.attr(src) || '';
			}
		}
		return '';
	};

$.magnificPopup.registerModule('image', {

	options: {
		markup: '<div class="mfp-figure">'+
					'<div class="mfp-close"></div>'+
					'<figure>'+
						'<div class="mfp-img"></div>'+
						'<figcaption>'+
							'<div class="mfp-bottom-bar">'+
								'<div class="mfp-title"></div>'+
								'<div class="mfp-counter"></div>'+
							'</div>'+
						'</figcaption>'+
					'</figure>'+
				'</div>',
		cursor: 'mfp-zoom-out-cur',
		titleSrc: 'title',
		verticalFit: true,
		tError: 'The image could not be loaded.'
	},

	proto: {
		initImage: function() {
			var imgSt = mfp.st.image,
				ns = '.image';

			mfp.types.push('image');

			_mfpOn(OPEN_EVENT+ns, function() {
				if(mfp.currItem.type === 'image' && imgSt.cursor) {
					$(document.body).addClass(imgSt.cursor);
				}
			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(imgSt.cursor) {
					$(document.body).removeClass(imgSt.cursor);
				}
				_window.off('resize' + EVENT_NS);
			});

			_mfpOn('Resize'+ns, mfp.resizeImage);
			if(mfp.isLowIE) {
				_mfpOn('AfterChange', mfp.resizeImage);
			}
		},
		resizeImage: function() {
			var item = mfp.currItem;
			if(!item || !item.img) return;

			if(mfp.st.image.verticalFit) {
				var decr = 0;
				// fix box-sizing in ie7/8
				if(mfp.isLowIE) {
					decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
				}
				item.img.css('max-height', mfp.wH-decr);
			}
		},
		_onImageHasSize: function(item) {
			if(item.img) {

				item.hasSize = true;

				if(_imgInterval) {
					clearInterval(_imgInterval);
				}

				item.isCheckingImgSize = false;

				_mfpTrigger('ImageHasSize', item);

				if(item.imgHidden) {
					if(mfp.content)
						mfp.content.removeClass('mfp-loading');

					item.imgHidden = false;
				}

			}
		},

		/**
		 * Function that loops until the image has size to display elements that rely on it asap
		 */
		findImageSize: function(item) {

			var counter = 0,
				img = item.img[0],
				mfpSetInterval = function(delay) {

					if(_imgInterval) {
						clearInterval(_imgInterval);
					}
					// decelerating interval that checks for size of an image
					_imgInterval = setInterval(function() {
						if(img.naturalWidth > 0) {
							mfp._onImageHasSize(item);
							return;
						}

						if(counter > 200) {
							clearInterval(_imgInterval);
						}

						counter++;
						if(counter === 3) {
							mfpSetInterval(10);
						} else if(counter === 40) {
							mfpSetInterval(50);
						} else if(counter === 100) {
							mfpSetInterval(500);
						}
					}, delay);
				};

			mfpSetInterval(1);
		},

		getImage: function(item, template) {

			var guard = 0,

				imgSt = mfp.st.image,

				// image error handler
				onLoadError = function() {
					if(item) {
						item.img.off('.mfploader');
						if(item === mfp.currItem){
							mfp._onImageHasSize(item);
							mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
						}

						item.hasSize = true;
						item.loaded = true;
						item.loadError = true;
					}
				},

				// image load complete handler
				onLoadComplete = function() {
					if(item) {
						if (item.img[0].complete) {
							item.img.off('.mfploader');

							if(item === mfp.currItem){
								mfp._onImageHasSize(item);

								mfp.updateStatus('ready');
							}

							item.hasSize = true;
							item.loaded = true;

							_mfpTrigger('ImageLoadComplete');

						}
						else {
							// if image complete check fails 200 times (20 sec), we assume that there was an error.
							guard++;
							if(guard < 200) {
								setTimeout(onLoadComplete,100);
							} else {
								onLoadError();
							}
						}
					}
				};
				


			var el = template.find('.mfp-img');
			if(el.length) {
				var img = document.createElement('img');
				img.className = 'mfp-img';
				if(item.el && item.el.find('img').length) {
					img.alt = item.el.find('img').attr('alt');
				}
				item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
				img.src = item.src;

				// without clone() "error" event is not firing when IMG is replaced by new IMG
				// TODO: find a way to avoid such cloning
				if(el.is('img')) {
					item.img = item.img.clone();
				}

				img = item.img[0];
				if(img.naturalWidth > 0) {
					item.hasSize = true;
				} else if(!img.width) {
					item.hasSize = false;
				}
			}

			mfp._parseMarkup(template, {
				title: _getTitle(item),
				img_replaceWith: item.img
			}, item);

			mfp.resizeImage();

			if(item.hasSize) {
				if(_imgInterval) clearInterval(_imgInterval);

				if(item.loadError) {
					template.addClass('mfp-loading');
					mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
				} else {
					template.removeClass('mfp-loading');
					mfp.updateStatus('ready');
				}
				return template;
			}

			mfp.updateStatus('loading');
			item.loading = true;

			if(!item.hasSize) {
				item.imgHidden = true;
				template.addClass('mfp-loading');
				mfp.findImageSize(item);
			}

			return template;
		}
	}
});

/*>>image*/

/*>>zoom*/
var hasMozTransform,
	getHasMozTransform = function() {
		if(hasMozTransform === undefined) {
			hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
		}
		return hasMozTransform;
	};

$.magnificPopup.registerModule('zoom', {

	options: {
		enabled: false,
		easing: 'ease-in-out',
		duration: 300,
		opener: function(element) {
			return element.is('img') ? element : element.find('img');
		}
	},

	proto: {

		initZoom: function() {
			var zoomSt = mfp.st.zoom,
				ns = '.zoom',
				image;

			if(!zoomSt.enabled || !mfp.supportsTransition) {
				return;
			}

			var duration = zoomSt.duration,
				getElToAnimate = function(image) {
					var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
						transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
						cssObj = {
							position: 'fixed',
							zIndex: 9999,
							left: 0,
							top: 0,
							'-webkit-backface-visibility': 'hidden'
						},
						t = 'transition';

					cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;

					newImg.css(cssObj);
					return newImg;
				},
				showMainContent = function() {
					mfp.content.css('visibility', 'visible');
				},
				openTimeout,
				animatedImg;

			_mfpOn('BuildControls'+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);
					mfp.content.css('visibility', 'hidden');

					// Basically, all code below does is clones existing image, puts in on top of the current one and animated it

					image = mfp._getItemToZoom();

					if(!image) {
						showMainContent();
						return;
					}

					animatedImg = getElToAnimate(image);

					animatedImg.css( mfp._getOffset() );

					mfp.wrap.append(animatedImg);

					openTimeout = setTimeout(function() {
						animatedImg.css( mfp._getOffset( true ) );
						openTimeout = setTimeout(function() {

							showMainContent();

							setTimeout(function() {
								animatedImg.remove();
								image = animatedImg = null;
								_mfpTrigger('ZoomAnimationEnded');
							}, 16); // avoid blink when switching images

						}, duration); // this timeout equals animation duration

					}, 16); // by adding this timeout we avoid short glitch at the beginning of animation


					// Lots of timeouts...
				}
			});
			_mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);

					mfp.st.removalDelay = duration;

					if(!image) {
						image = mfp._getItemToZoom();
						if(!image) {
							return;
						}
						animatedImg = getElToAnimate(image);
					}

					animatedImg.css( mfp._getOffset(true) );
					mfp.wrap.append(animatedImg);
					mfp.content.css('visibility', 'hidden');

					setTimeout(function() {
						animatedImg.css( mfp._getOffset() );
					}, 16);
				}

			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {
					showMainContent();
					if(animatedImg) {
						animatedImg.remove();
					}
					image = null;
				}
			});
		},

		_allowZoom: function() {
			return mfp.currItem.type === 'image';
		},

		_getItemToZoom: function() {
			if(mfp.currItem.hasSize) {
				return mfp.currItem.img;
			} else {
				return false;
			}
		},

		// Get element postion relative to viewport
		_getOffset: function(isLarge) {
			var el;
			if(isLarge) {
				el = mfp.currItem.img;
			} else {
				el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
			}

			var offset = el.offset();
			var paddingTop = parseInt(el.css('padding-top'),10);
			var paddingBottom = parseInt(el.css('padding-bottom'),10);
			offset.top -= ( $(window).scrollTop() - paddingTop );


			/*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
			var obj = {
				width: el.width(),
				// fix Zepto height+padding issue
				height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
			};

			// I hate to do this, but there is no another option
			if( getHasMozTransform() ) {
				obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
			} else {
				obj.left = offset.left;
				obj.top = offset.top;
			}
			return obj;
		}

	}
});



/*>>zoom*/

/*>>iframe*/

var IFRAME_NS = 'iframe',
	_emptyPage = '//about:blank',

	_fixIframeBugs = function(isShowing) {
		if(mfp.currTemplate[IFRAME_NS]) {
			var el = mfp.currTemplate[IFRAME_NS].find('iframe');
			if(el.length) {
				// reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
				if(!isShowing) {
					el[0].src = _emptyPage;
				}

				// IE8 black screen bug fix
				if(mfp.isIE8) {
					el.css('display', isShowing ? 'block' : 'none');
				}
			}
		}
	};

$.magnificPopup.registerModule(IFRAME_NS, {

	options: {
		markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
				'</div>',

		srcAction: 'iframe_src',

		// we don't care and support only one default type of URL by default
		patterns: {
			youtube: {
				index: 'youtube.com',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			},
			gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			}
		}
	},

	proto: {
		initIframe: function() {
			mfp.types.push(IFRAME_NS);

			_mfpOn('BeforeChange', function(e, prevType, newType) {
				if(prevType !== newType) {
					if(prevType === IFRAME_NS) {
						_fixIframeBugs(); // iframe if removed
					} else if(newType === IFRAME_NS) {
						_fixIframeBugs(true); // iframe is showing
					}
				}// else {
					// iframe source is switched, don't do anything
				//}
			});

			_mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
				_fixIframeBugs();
			});
		},

		getIframe: function(item, template) {
			var embedSrc = item.src;
			var iframeSt = mfp.st.iframe;

			$.each(iframeSt.patterns, function() {
				if(embedSrc.indexOf( this.index ) > -1) {
					if(this.id) {
						if(typeof this.id === 'string') {
							embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
						} else {
							embedSrc = this.id.call( this, embedSrc );
						}
					}
					embedSrc = this.src.replace('%id%', embedSrc );
					return false; // break;
				}
			});

			var dataObj = {};
			if(iframeSt.srcAction) {
				dataObj[iframeSt.srcAction] = embedSrc;
			}

			mfp._parseMarkup(template, dataObj, item);

			mfp.updateStatus('ready');

			return template;
		}
	}
});



/*>>iframe*/

/*>>gallery*/
/**
 * Get looped index depending on number of slides
 */
var _getLoopedId = function(index) {
		var numSlides = mfp.items.length;
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},
	_replaceCurrTotal = function(text, curr, total) {
		return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
	};

$.magnificPopup.registerModule('gallery', {

	options: {
		enabled: false,
		arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
		preload: [0,2],
		navigateByImgClick: true,
		arrows: true,

		tPrev: 'Previous (Left arrow key)',
		tNext: 'Next (Right arrow key)',
		tCounter: '%curr% of %total%',
		
		langDir: null,
		loop: true,
	},

	proto: {
		initGallery: function() {

			var gSt = mfp.st.gallery,
				ns = '.mfp-gallery';

			mfp.direction = true; // true - next, false - prev

			if(!gSt || !gSt.enabled ) return false;
			
			if (!gSt.langDir) {
				gSt.langDir = document.dir || 'ltr';
			}

			_wrapClasses += ' mfp-gallery';

			_mfpOn(OPEN_EVENT+ns, function() {

				if(gSt.navigateByImgClick) {
					mfp.wrap.on('click'+ns, '.mfp-img', function() {
						if(mfp.items.length > 1) {
							mfp.next();
							return false;
						}
					});
				}

				_document.on('keydown'+ns, function(e) {
					if (e.keyCode === 37) {
						if (gSt.langDir === 'rtl') mfp.next();
						else mfp.prev();
					} else if (e.keyCode === 39) {
						if (gSt.langDir === 'rtl') mfp.prev();
						else mfp.next();
					}
				});

				mfp.updateGalleryButtons();

			});

			_mfpOn('UpdateStatus'+ns, function(/*e, data*/) {
				mfp.updateGalleryButtons();
			});

			_mfpOn('UpdateStatus'+ns, function(e, data) {
				if(data.text) {
					data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
				}
			});

			_mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
				var l = mfp.items.length;
				values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
			});

			_mfpOn('BuildControls' + ns, function() {
				if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {

					var arrowLeftDesc, arrowRightDesc, arrowLeftAction, arrowRightAction;

					if (gSt.langDir === 'rtl') {
						arrowLeftDesc = gSt.tNext;
						arrowRightDesc = gSt.tPrev;
						arrowLeftAction = 'next';
						arrowRightAction = 'prev';
					} else {
						arrowLeftDesc = gSt.tPrev;
						arrowRightDesc = gSt.tNext;
						arrowLeftAction = 'prev';
						arrowRightAction = 'next';
					}

					var markup     = gSt.arrowMarkup,
					    arrowLeft  = mfp.arrowLeft = $( markup.replace(/%title%/gi, arrowLeftDesc).replace(/%action%/gi, arrowLeftAction).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
					    arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, arrowRightDesc).replace(/%action%/gi, arrowRightAction).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);

					if (gSt.langDir === 'rtl') {
						mfp.arrowNext = arrowLeft;
						mfp.arrowPrev = arrowRight;
					} else {
						mfp.arrowNext = arrowRight;
						mfp.arrowPrev = arrowLeft;
					}

					arrowLeft.on('click', function() {
						if (gSt.langDir === 'rtl') mfp.next();
						else mfp.prev();
					});
					arrowRight.on('click', function() {
						if (gSt.langDir === 'rtl') mfp.prev();
						else mfp.next();
					});

					mfp.container.append(arrowLeft.add(arrowRight));

				}
			});

			_mfpOn(CHANGE_EVENT+ns, function() {
				if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

				mfp._preloadTimeout = setTimeout(function() {
					mfp.preloadNearbyImages();
					mfp._preloadTimeout = null;
				}, 16);
			});


			_mfpOn(CLOSE_EVENT+ns, function() {
				_document.off(ns);
				mfp.wrap.off('click'+ns);
				mfp.arrowRight = mfp.arrowLeft = null;
			});

		},
		next: function() {
			var newIndex = _getLoopedId(mfp.index + 1);
			if (!mfp.st.gallery.loop && newIndex === 0 ) return false;
			mfp.direction = true;
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		prev: function() {
			var newIndex = mfp.index - 1;
			if (!mfp.st.gallery.loop && newIndex < 0) return false;
			mfp.direction = false;
			mfp.index = _getLoopedId(newIndex);
			mfp.updateItemHTML();
		},
		goTo: function(newIndex) {
			mfp.direction = (newIndex >= mfp.index);
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		preloadNearbyImages: function() {
			var p = mfp.st.gallery.preload,
				preloadBefore = Math.min(p[0], mfp.items.length),
				preloadAfter = Math.min(p[1], mfp.items.length),
				i;

			for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
				mfp._preloadItem(mfp.index+i);
			}
			for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
				mfp._preloadItem(mfp.index-i);
			}
		},
		_preloadItem: function(index) {
			index = _getLoopedId(index);

			if(mfp.items[index].preloaded) {
				return;
			}

			var item = mfp.items[index];
			if(!item.parsed) {
				item = mfp.parseEl( index );
			}

			_mfpTrigger('LazyLoad', item);

			if(item.type === 'image') {
				item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
					item.hasSize = true;
				}).on('error.mfploader', function() {
					item.hasSize = true;
					item.loadError = true;
					_mfpTrigger('LazyLoadError', item);
				}).attr('src', item.src);
			}


			item.preloaded = true;
		},

		/**
		 * Show/hide the gallery prev/next buttons if we're at the start/end, if looping is turned off
		 * Added by Joloco for Veg
		 */
		updateGalleryButtons: function() {

			if ( !mfp.st.gallery.loop && typeof mfp.arrowPrev === 'object' && mfp.arrowPrev !== null) {

				if (mfp.index === 0) mfp.arrowPrev.hide();
				else mfp.arrowPrev.show();

				if (mfp.index === (mfp.items.length - 1)) mfp.arrowNext.hide();
				else mfp.arrowNext.show();

			}

		},

	}

});


/*>>gallery*/

/*>>retina*/

var RETINA_NS = 'retina';

$.magnificPopup.registerModule(RETINA_NS, {
	options: {
		replaceSrc: function(item) {
			return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
		},
		ratio: 1 // Function or number.  Set to 1 to disable.
	},
	proto: {
		initRetina: function() {
			if(window.devicePixelRatio > 1) {

				var st = mfp.st.retina,
					ratio = st.ratio;

				ratio = !isNaN(ratio) ? ratio : ratio();

				if(ratio > 1) {
					_mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
						item.img.css({
							'max-width': item.img[0].naturalWidth / ratio,
							'width': '100%'
						});
					});
					_mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
						item.src = st.replaceSrc(item, ratio);
					});
				}
			}

		}
	}
});

/*>>retina*/
 _checkInstance(); }));

// Components
var accordion = {
    init: function() {
        $('.js-accordion-item:not(.accordion-item--open) .js-accordion-item__content').slideUp(0);
        this.setListeners();
    },
    setListeners: function() {
        $('.js-accordion-item').find('.js-accordion-action').click(function(e) {
            e.preventDefault();
            var accordionItem = $(this).closest('.js-accordion-item');
            accordionItem.toggleClass('accordion-item--open');
            accordionItem.find('.js-accordion-item__content').slideToggle();
        });
    }
};

;(function (app) {
    app.AttributeSelector = {
        init: function () {
            this.setListeners();
        },
        setListeners: function () {
            var module = this;
            $(document).on('change', 'select.js-updates-options', function (e) {
                e.preventDefault();
                module.loadNew($(this).val());
            });
            $(document).on('click', 'a.js-updates-options', function (e) {
                e.preventDefault();
                module.loadNew($(this).attr('href'));
            });
        },
        loadNew: function (url) {
            var productOptionsWrap = $('.js-product-options');
            var galleryWrap = $('.js-thumbnail-gallery');
            var variantPrice = $('.js-variant-price');
            var variantFit = $('.js-variant-fit');
            var productOptions = productOptionsWrap.find('.product-options');
            productOptions.addClass('product-options--working');
            $.get(url, function (data) {
                history.pushState(
                    {
                        type: 'product-detail-option--url',
                        url: url
                    },
                    null,
                    url
                );
                productOptionsWrap.html(data.payload.productOptionsHtml);
                galleryWrap.html(data.payload.gallery);
                variantPrice.html(data.payload.price);
                if ('string' === typeof data.payload.fit) {
                    variantFit.html(data.payload.fit);
                }
                app.components.selectReplace.init($('select'), 'icon-select');
                thumbnailGallery.init();
                smoothScroll.init();
                videoOverlay.init();
                $('.js-help-modal').magnificPopup({
                    type: 'ajax',
                    mainClass: 'mfp--help',
                })
            });
        }
    };
})(window.Bespoke = window.Bespoke || {});

var basketChange;
$(document).on('change', '.basket__table select', function() {
    if (basketChange != null) {
        basketChange.abort();
    }
    basketChange = $.ajax('/basket/update', {
        type: 'POST',
        data: $('.basket__table input, .basket__table select').serialize(),
        success: function(data) {
            if (data.result) {
                $('.js-basket-table-target').html(data.payload.table);
                $('.js-basket-action-target').html(data.payload.action);
                Bespoke.components.selectReplace.init($('.basket__table select'));
            }
        }
    });
});

(function ($) {

    var lazyListingHovers = $('.js-lazy-listing-hover');

    lazyListingHovers.each(function(i, element) {
        var element = $(element);
        var img = $('<img>').attr('src', element.data('lazy-hover-src'));
        var wrapper = $('<div>').attr('class', 'listing-item__hover-image').html(img);
        element.append(wrapper);
    });
})(jQuery);
var cards = {
    init: function() {
        cards.cardGroups = $('.js-match-card-height');
        cards.setListeners();
    },
    setListeners: function() {
        if (!cards.cardGroups.length) {
            return false;
        }

        $(window).resize(function() {
            cards.cardGroups.each(function() {
                var cards = $(this).find('.card'),
                    tallestHeadHeight = 0,
                    tallestBodyHeight = 0;

                cards.each(function() {
                    var card = $(this);
                    // reset the min height back to 0.
                    card.find('.card__head').css('min-height', 0);
                    card.find('.card__body').css('min-height', 0);

                    var head = card.find('.card__head');
                    var body = card.find('.card__body');
                    if (head.outerHeight() > tallestHeadHeight) {
                        tallestHeadHeight = head.outerHeight();
                    }
                    if (body.outerHeight() > tallestBodyHeight) {
                        tallestBodyHeight = body.outerHeight();
                    }
                });

                cards.each(function() {
                    var card = $(this);
                    if (screenSize.isSmallerThan('phablet')) {
                        card.find('.card__head').css('min-height', tallestHeadHeight);
                        card.find('.card__body').css('min-height', tallestBodyHeight);
                    } else {
                        card.find('.card__head').css('min-height', 0);
                        card.find('.card__body').css('min-height', 0);
                    }

                });
            });
        });

        $(window).trigger('resize');
    }
};

document.addEventListener('DOMContentLoaded', function () {
    $('input[type=checkbox]').not('[ignore]').not('.account-form-toggle__switch').checkReplace();
    $('input[type=radio]').radioReplace();
});

var preventScroll = {
    on: function() {
        var htmlEl = document.querySelector('html');
        var body = document.body;

        // Determine the `scrollTop` to use. Some browsers require checking the
        // `body`, others use `html`.
        var bodyScrollTop = body.scrollTop;
        var htmlScrollTop = htmlEl.scrollTop;
        var scrollTop = bodyScrollTop ? bodyScrollTop : htmlScrollTop;

        // Store the current value of the htmlEl's styles – we're about to override
        // them.
        this.currentPosition = htmlEl.style.position;
        this.currentOverflow = htmlEl.style.overflowY;
        this.currentWidth = htmlEl.style.width;

        // Fixing the position of the `htmlEl` prevents the page from scrolling
        // at all.
        htmlEl.style.position = 'fixed';
        // Setting `overflowY` to `scroll` ensures that any scrollbars that are
        // around stick around. Otherwise, there would be a "jump" when the page
        // becomes unscrollable as the bar would vanish.
        htmlEl.style.overflowY = 'scroll';
        // This makes sure that the page doesn't collapse (usually your CSS will
        // prevent this, but it's best to be safe)
        htmlEl.style.width = '100%';
        // Scoot down the `htmlEl` to be in the same place that the user had
        // scrolled to.
        htmlEl.style.top = (0 - scrollTop) + 'px';
    },

    off: function() {
        var htmlEl = document.querySelector('html');
        var body = document.body;

        // Reset `htmlEl` to the original styles.
        htmlEl.style.position = this.currentPosition;
        htmlEl.style.overflowY = this.currentOverflow;
        htmlEl.style.width = this.currentWidth;

        // Retrieve our original scrollTop from the htmlEl's top
        var scrollTop = -parseInt(htmlEl.style.top);
        // Return us to the original scroll position. Once again, we set this on
        // both the `body` and the `htmlEl` to be safe.
        htmlEl.scrollTop = scrollTop;
        body.scrollTop = scrollTop;
    }
}


var Filters = function () {

    var self = this;

    this.init = function () {
        var form = document.querySelector('.js-filters-reload');
        if (form !== null) {
            var selects = $(form).find('select');
            selects.change(function(e) {
                $(form).find(':input[value=""]').attr('disabled', true);
                $(form).submit();
                $(form).find(':input[value=""]').attr('disabled', false);
            });
        }

        this.filters = document.querySelector('.js-filters-reload,.js-filters');

        if (this.filters === null) {
            return;
        }

        this.search = document.querySelector('.js-search');
        this.container = this.filters.querySelector('.js-filters-sticky-container');
        this.selects = this.filters.classList.contains('js-filters-reload') ? $(this.filters).find('select, input[type="checkbox"], input[type="radio"]') : null;
        this.toggle = document.querySelector('.js-filter-toggle');
        this.apply = document.querySelector('.js-filters-apply');
        var itemFilters = document.querySelector('.accordion-item--filter');

        if (itemFilters) {
            this.category = itemFilters.querySelector('.js-accordion-action');
        }

        this.detectLayout();
        this.setListeners();

        window.addEventListener(window.Listing.Events.UPDATED, function() {
            self.init();
        })
    };

    this.setListeners = function () {
        if (this.selects) {
            this.selects.change(function (e) {
                $(self.filters).find(':input[value=""]').attr('disabled', true);
                $(self.filters).submit();
                $(self.filters).find(':input[value=""]').attr('disabled', false);
            });
        }

        if (this.toggle) {
            this.toggle.onclick = function (e) {
                e.preventDefault();

                if (self.filters.classList.contains('filters--active')) {
                    self.hide();
                } else {
                    self.show();
                }
            };
        }

        if (this.apply) {
            this.apply.onclick = function (e) {
                e.preventDefault();
                self.hide();
            };
        }

        var windowResizing;

        window.addEventListener('resize', function () {
            clearTimeout(windowResizing);
            windowResizing = setTimeout(function () {
                self.detectLayout();
                if (!self.mobileLayout && self.filters.classList.contains('filters--active')) {
                    self.hide();
                }
            }, 100);
        });
    };

    this.show = function () {
        this.filters.classList.add('filters--active');
        this.container.classList.add('filters__filters--fixed');
        this.toggle.classList.add('filter-button--active');
        preventScroll.on();
    };

    this.hide = function () {
        this.filters.classList.remove('filters--active');
        this.container.classList.remove('filters__filters--fixed');
        this.toggle.classList.remove('filter-button--active');
        preventScroll.off();
    };

    this.detectLayout = function () {
        this.mobileLayout = window.matchMedia('(max-width: 1000px)').matches;
    }
};

var filters = new Filters();

var preventScroll = {
    on: function() {
        var htmlEl = document.querySelector('html');
        var body = document.body;

        // Determine the `scrollTop` to use. Some browsers require checking the
        // `body`, others use `html`.
        var bodyScrollTop = body.scrollTop;
        var htmlScrollTop = htmlEl.scrollTop;
        var scrollTop = bodyScrollTop ? bodyScrollTop : htmlScrollTop;

        // Store the current value of the htmlEl's styles – we're about to override
        // them.
        this.currentPosition = htmlEl.style.position;
        this.currentOverflow = htmlEl.style.overflowY;
        this.currentWidth = htmlEl.style.width;

        // Fixing the position of the `htmlEl` prevents the page from scrolling
        // at all.
        htmlEl.style.position = 'fixed';
        // Setting `overflowY` to `scroll` ensures that any scrollbars that are
        // around stick around. Otherwise, there would be a "jump" when the page
        // becomes unscrollable as the bar would vanish.
        htmlEl.style.overflowY = 'scroll';
        // This makes sure that the page doesn't collapse (usually your CSS will
        // prevent this, but it's best to be safe)
        htmlEl.style.width = '100%';
        // Scoot down the `htmlEl` to be in the same place that the user had
        // scrolled to.
        htmlEl.style.top = (0 - scrollTop) + 'px';
    },

    off: function() {
        var htmlEl = document.querySelector('html');
        var body = document.body;

        // Reset `htmlEl` to the original styles.
        htmlEl.style.position = this.currentPosition;
        htmlEl.style.overflowY = this.currentOverflow;
        htmlEl.style.width = this.currentWidth;

        // Retrieve our original scrollTop from the htmlEl's top
        var scrollTop = -parseInt(htmlEl.style.top);
        // Return us to the original scroll position. Once again, we set this on
        // both the `body` and the `htmlEl` to be safe.
        htmlEl.scrollTop = scrollTop;
        body.scrollTop = scrollTop;
    }
}


var header = {
    toggle: null,
    wrap: null,
    nav: null,
    stickyWrap: null,
    stickyActive: false,
    heroHeight: null,
    headerNavOpenClass: 'header--nav-open',
    navOpenClass: 'nav--open',
    navChildOpenClass: 'nav__item--open',
    navChildReadyClass: 'nav__item--ready',
    bodyCoverActiveClass: 'body-cover--active',
    init: function() {
        header.toggle = $('.js-navigation-toggle');
        header.toggleChildren = $('.js-navigation-toggle-children');
        header.wrap = $('.js-header');
        header.nav = $('.js-nav');
        header.bodyCover = $('.js-body-cover');
        header.heroHeight = $('.hero').height();
        if (!header.wrap.hasClass('js-header--static')) {
            header.setupSticky();
        }
        header.setListeners();
    },
    setupSticky: function() {
        header.stickyWrap = header
            .wrap
            .clone()
            .addClass('header--sticky');
        header.stickyWrap
            .find('.nav')
            .addClass('nav--dark');
        $('#outer-wrapper').append(header.stickyWrap);

        header.toggleChildren = $('.js-navigation-toggle-children');
    },
    setListeners: function() {
        var removeOpenClass;

        header.detectLayout();

        header.toggle.click(function(e) {
            e.preventDefault();
            header.updateToggleState();
            $('.' + header.navChildOpenClass).removeClass(header.navChildOpenClass);
            $('.' + header.navChildReadyClass).removeClass(header.navChildReadyClass);
        });
        header.toggleChildren.click(function(e) {
            if (window.matchMedia('(max-width: 1000px)').matches) {
                e.preventDefault();
                $(this).toggleClass(header.navChildOpenClass);
            }
        });
        header.toggleChildren.find('.nav__children a').click(function(e) {
            e.stopPropagation();
        });
        header.toggleChildren.hover(function() {
            if (!window.matchMedia('(max-width: 1000px)').matches) {
                var el = $(this);
                el.addClass(header.navChildOpenClass);
                el.find('.nav__children-helper').width($(this).width()).css({
                    left: el.position().left
                });
                clearTimeout(removeOpenClass);
                setTimeout(function() {
                    el.addClass(header.navChildReadyClass);
                }, 100);
            }
        }, function() {
            if (!window.matchMedia('(max-width: 1000px)').matches) {
                var el = $(this);
                el.removeClass(header.navChildReadyClass);
                removeOpenClass = setTimeout(function() {
                    el.removeClass(header.navChildOpenClass);
                }, 200);
            }
        });
        header.bodyCover.click(function(e) {
            e.preventDefault();
            header.updateToggleState();
        });

        if (!header.wrap.hasClass('js-header--static')) {
            var windowResizing;

            window.addEventListener('resize', function() {
                clearTimeout(windowResizing);
                windowResizing = setTimeout(function() {
                    header.detectLayout();
                    if (header.mobileLayout && header.nav.hasClass(header.navOpenClass)) {
                        header.resizeNav();
                    }
                    if (!header.mobileLayout && header.nav.hasClass(header.navOpenClass)) {
                        header.closeNav();
                    }
                    header.heroHeight = $('.hero').height();
                }, 100);
            });

            $(document).scroll(function() {
                if ($(document).scrollTop() >=  header.heroHeight) {
                    // show sticky nav
                    if (!header.stickyActive) {
                        header.stickyWrap.addClass('header--sticky-active');
                        header.stickyActive = true;
                    }
                } else {
                    // hide stick nav
                    if (header.stickyActive) {
                        header.stickyWrap.removeClass('header--sticky-active');
                        header.stickyActive = false;
                    }
                }
            });
        }
    },
    updateToggleState: function() {
        if (header.wrap.hasClass(header.headerNavOpenClass)) {
            header.closeNav();
        } else {
            header.openNav();
        }
    },
    openNav: function() {
        header.wrap.addClass(header.headerNavOpenClass);
        header.nav.addClass(header.navOpenClass);
        header.bodyCover.addClass(header.bodyCoverActiveClass);
        header.resizeNav();
        preventScroll.on();
    },
    closeNav: function() {
        header.wrap.removeClass(header.headerNavOpenClass);
        header.nav.removeClass(header.navOpenClass);
        header.bodyCover.removeClass(header.bodyCoverActiveClass);
        header.nav.attr('style', '');
        preventScroll.off();
    },
    resizeNav: function() {
        header.nav.height(window.innerHeight - header.wrap.height());
    },
    detectLayout: function() {
        header.mobileLayout = window.matchMedia('(max-width: 1000px)').matches;
    }
};

jQuery(document).ready(function($){
    var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.js-image-comp');

    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(
            actual.find('.js-image-comp__handle'),
            actual.find('.js-image-comp__resize-image'),
            actual
        );
    });

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container) {
        dragElement.on("mousedown touchstart", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - getPageX(e),
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;

            dragElement.parents().on("mousemove touchmove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement);});
                }
            }).on("mouseup touchend", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup touchend", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement) {
        var leftValue = getPageX(e) + xPosition - dragWidth;
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';

        $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue);

        dragging =  false;
    }

    function getPageX(event) {
        if (event.type == 'touchmove' || event.type == 'touchstart' || event.type == 'touchend') {
            return event.originalEvent.touches[0].pageX;
        }
        return event.pageX;
    }
});
function initialiseGoogleMap(mapId, center, zoom) {
    var mapId = "#" + mapId;
    var options = {
        center: center,
        zoom: zoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        draggable: false,
        disableDefaultUI: true
    };

    var icon = {
        url: "/images/map/pin.svg",
        size: new google.maps.Size(30, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 45),
        scaledSize: new google.maps.Size(30, 48)
    };

    var map = new google.maps.Map($(mapId).get(0), options);
    var marker = new google.maps.Marker({
        animation: google.maps.Animation.DROP,
        position: center,
        icon: icon,
        clickable: false,
        title: "Bespoke Cycling"
    });

    marker.setMap(map);

    // updating the bounds is, nasty
    setTimeout(function() {
        center = map.getCenter();
    }, 1000);

    google.maps.event.addListener(map, "dragend", function() {
        center = map.getCenter();
    });

    google.maps.event.addDomListener(window, "resize", function(){
        map.setCenter(center);
        google.maps.event.trigger(map, "resize")
    });
}
var nav = {
    target: 'js-nav__item',
    className: 'nav__item--active',
    init: function() {
        var self = this;

        $('.' + this.target).each(function() {
            if ($(this).attr('href') == window.location.pathname + window.location.hash) {
                self.update($(this));
            }
            $(this).click(function() {
                self.update($(this));
            });
        });
    },
    update: function(el) {
        var self = this;

        $('.' + self.className).removeClass(self.className);
        el.addClass(self.className);
    }
};

var overlay = {
    overlayClass: 'body-overlay',
    get: function() {
        return $('.' + overlay.overlayClass);
    },
    apply: function(content) {
        var overlayObject = overlay.get();
        if (overlayObject.length == 0) {
            overlayObject = $('<a href="#" class="'+ overlay.overlayClass +'">');
            $('body').append(overlayObject);
        }

        $('.body-overlay__content', overlayObject).html('').append(content);

        $('.js-body-overlay-close').off('click').click(function(e) {
            e.preventDefault();
            overlay.remove();
        });

        overlay.get().fadeIn(200, function() {
            $(this).addClass('body-overlay--active');
        });

        return overlayObject;
    },
    remove: function() {
        overlay.get().fadeOut(200, function() {
            $(this).removeClass('body-overlay--active');
            $('.body-overlay__content', overlay.get()).html('');
        });
    }
};

var initPhotoSwipe = function() {
    var pswpElement = document.querySelectorAll('.pswp')[0];

    $(document)
        .on('click', '[data-photoswipe]', function(e) {
            var link = $(this),
                galleryKey = link.data('photoswipe'),
                imageId = link.data('photoswipe-id'),
                images = window[galleryKey],
                options = {},
                imageIndex, gallery;

            e.preventDefault();

            if (!images) {
                throw 'No images could be found for key ' + galleryKey;
            }

            $.each(images, function(i, v) {
                if (parseInt(v.id, 10) === parseInt(imageId, 10)) {
                    imageIndex = i;
                    return false;
                }
            });

            if (typeof imageIndex !== 'undefined') {
                options.index = imageIndex;
            }

            gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, options);
            gallery.init(options);
        });
};

initPhotoSwipe();

var richtextTable = {
    table: {},
    init: function() {
        richtextTable.table = $('.richtext-table__inner');
        richtextTable.setListeners();
        richtextTable.updatePreviews(richtextTable.table);
    },
    setListeners: function() {
        $(window).resize(function() {
            richtextTable.updatePreviews(richtextTable.table)
        });
        richtextTable.table.scroll(function() {
            richtextTable.updatePreviews($(this))
        });
    },
    updatePreviews: function(table) {
        var parentWrap = table.parent('.richtext-table');
        var tableElement = table.find('table');
        var scrollLeft = table.scrollLeft();
        var scrollRight = tableElement.outerWidth() - table.outerWidth() - scrollLeft;

        parentWrap.toggleClass('richtext-table--reveal-before', scrollLeft != 0);
        parentWrap.toggleClass('richtext-table--reveal-after', scrollRight != 0);
    }
};

richtextTable.init();
(function($) {
    $('.hero__scroll-prompt').click(function(e) {
        e.preventDefault();
        // Variables not cached for responsive reasons. Even thought it's slightly
        // more work to not cache the heights, this button is not going to be
        // pressed a great deal.

        // if there's a sticky nav, do this
        $('body,html').stop().animate({scrollTop:$('.hero').height()+$('header').height()-50}, '1000', 'swing', function() {
            // Nothing Here
        });
    });
})(jQuery);

(function($) {
    $('.js-scroll-top').click(function(e) {
        e.preventDefault();
        $('body,html').stop().animate({scrollTop:0}, '1000', 'swing', function() {
            // Nothing Here
        });
    });
})(jQuery);

;(function (app) {
    app.components = app.components || {};

    var initSelectReplace = function (target, icon) {
        if ('undefined' === typeof icon) {
            icon = target.data('select-replace-style') === 'alt' ? 'icon-chevron-down' : 'icon-select'
        }
        target.selectreplace({
            wrapper: 'div',
            wrapperClass: 'select-replace',
            value: 'p',
            valueClass: 'select-replace__value',
            svgIcon: icon
        });
    };

    initSelectReplace($('select').not('[data-select-replace-style="alt"]'), 'icon-select');
    initSelectReplace($('select[data-select-replace-style="alt"]'), 'icon-chevron-down');

    /**
     * @exports Bespoke.components
     * @type {{init: initSelectReplace}}
     */
    app.components.selectReplace = {
        init: initSelectReplace
    }
})(window.Bespoke = window.Bespoke || {});

var sidebarGallery = {
    container: {},
    thumbs: {},
    firstItem: {},
    scrollPosition: 0,
    totalThumbCount: 0,
    activeThumbPosition: 0,
    totalPerPage: 6,
    init: function () {
        sidebarGallery.container = $('.js-sidebar-gallery');
        sidebarGallery.thumbs = $('.sidebar-gallery__thumb', sidebarGallery.container);
        sidebarGallery.firstThumb = $('.sidebar-gallery__thumb:first', sidebarGallery.container);
        sidebarGallery.totalThumbCount = sidebarGallery.thumbs.length;
        sidebarGallery.initSlider();
        sidebarGallery.setListeners();
    },
    initSlider: function() {
        $('.js-sidebar-gallery').slider({
            item: '.slider__slide',
            autoplay: false,
            debug: false,
            onSelectCallback: function() {
                sidebarGallery.updateStatus();
            }
        });
    },
    updateStatus: function() {
        sidebarGallery.activeThumbPosition = $('.slider__nav__item--active').prevAll().length;
        sidebarGallery.updateNavigationArrows();
        if (sidebarGallery.totalThumbCount <= sidebarGallery.totalPerPage) {
            return false;
        }

        if (
            (sidebarGallery.activeThumbPosition - sidebarGallery.scrollPosition) == (sidebarGallery.totalPerPage - 1)
            && (sidebarGallery.totalThumbCount - sidebarGallery.totalPerPage) > sidebarGallery.scrollPosition) {
            sidebarGallery.scrollPosition++;
        } else if ((sidebarGallery.activeThumbPosition - sidebarGallery.scrollPosition) == 0 && sidebarGallery.scrollPosition > 0) {
            sidebarGallery.scrollPosition--;
        }
        sidebarGallery.animate();
    },
    setListeners: function () {
        $('.sidebar-gallery__scroll-arrow', sidebarGallery.container)
            .off('click.sidebar-gallery__scroll-arrow')
            .on('click.sidebar-gallery__scroll-arrow', function (e) {
            e.preventDefault();
            if ($(this).attr('data-scroll') == 'up' && sidebarGallery.scrollPosition > 0) {
                sidebarGallery.scrollPosition--;
            } else {
                sidebarGallery.scrollPosition++;
            }
            sidebarGallery.animate();
            sidebarGallery.updateNavigationArrows();
        });
        $('.slider__prev, .slider__next').off('click.slider__prev').on('click.slider__prev', function(e) {
            e.preventDefault();
            sidebarGallery.updateNavigationArrows();
        });
    },
    animate: function() {
        sidebarGallery.firstThumb.animate({
            'margin-top': - sidebarGallery.thumbs.outerHeight() * (sidebarGallery.scrollPosition)
        });
    },
    updateNavigationArrows: function() {
        if (sidebarGallery.scrollPosition == 0) {
            $('.sidebar-gallery__scroll-arrow--up').addClass('sidebar-gallery__scroll-arrow--disabled');
        } else {
            $('.sidebar-gallery__scroll-arrow--up').removeClass('sidebar-gallery__scroll-arrow--disabled');
        }

        if (sidebarGallery.totalThumbCount == (sidebarGallery.scrollPosition + sidebarGallery.totalPerPage)) {
            $('.sidebar-gallery__scroll-arrow--down').addClass('sidebar-gallery__scroll-arrow--disabled');
        } else {
            $('.sidebar-gallery__scroll-arrow--down').removeClass('sidebar-gallery__scroll-arrow--disabled');
        }

        if (sidebarGallery.activeThumbPosition == (sidebarGallery.totalThumbCount - 1)) {
            $('.slider__next').addClass('slider__next--disabled');
        } else {
            $('.slider__next').removeClass('slider__next--disabled');
        }

        if (sidebarGallery.activeThumbPosition == 0) {
            $('.slider__prev').addClass('slider__prev--disabled');
        } else {
            $('.slider__prev').removeClass('slider__prev--disabled');
        }
    }
};

var initSliders = function() {
    $('.slider:not(.thumbnail-gallery)').slider({
        item: '.slider__slide',
        autoplay: false,
        debug: false,
        autodelay: 6000
    });
};

initSliders();
var smoothScroll = {
    init: function() {
        $('.js-smooth-scroll').click(function(e) {
            e.preventDefault();
            var scrollTo = $($(this).attr('href'));
            $('body,html').stop().animate({scrollTop:scrollTo.offset().top}, '1000', 'swing', function() {
                // This smooth scroll will scroll to 'snap-tags'. These are tags with the target ID nested
                // within the corresponding band. The tags are position relative, with negative top values
                // to adjust for the header height.
            });
        });
    }
};

smoothScroll.init();

var thumbnailGallery = {
    container: {},
    thumbs: {},
    firstItem: {},
    totalThumbCount: 0,
    activeThumbPosition: 0,
    totalPerPage: 6,
    init: function () {
        thumbnailGallery.container = $('.js-thumbnail-gallery');
        thumbnailGallery.thumbs = $('.thumbnail-gallery__thumb', thumbnailGallery.container);
        thumbnailGallery.firstThumb = $('.thumbnail-gallery__thumb:first', thumbnailGallery.container);
        thumbnailGallery.totalThumbCount = thumbnailGallery.thumbs.length;
        thumbnailGallery.initSlider();
        thumbnailGallery.setListeners();
    },
    initSlider: function() {
        $('.js-thumbnail-gallery').slider({
            item: '.slider__slide',
            autoplay: false,
            debug: false,
            onSelectCallback: function() {
                thumbnailGallery.updateStatus();
            }
        });
    },
    updateStatus: function() {
        thumbnailGallery.activeThumbPosition = $('.slider__nav__item--active').prevAll().length;
        thumbnailGallery.updateNavigationArrows();
        if (thumbnailGallery.totalThumbCount <= thumbnailGallery.totalPerPage) {
            return false;
        }
    },
    setListeners: function () {
        $('.slider__prev, .slider__next').off('click.slider__prev').on('click.slider__prev', function(e) {
            e.preventDefault();
            thumbnailGallery.updateNavigationArrows();
        });
    },
    updateNavigationArrows: function() {
        if (thumbnailGallery.activeThumbPosition === (thumbnailGallery.totalThumbCount - 1)) {
            $('.slider__next').addClass('slider__next--disabled');
        } else {
            $('.slider__next').removeClass('slider__next--disabled');
        }

        if (thumbnailGallery.activeThumbPosition == 0) {
            $('.slider__prev').addClass('slider__prev--disabled');
        } else {
            $('.slider__prev').removeClass('slider__prev--disabled');
        }
    }
};

var videoOverlay = {
    init: function() {
        videoOverlay.setListeners();
    },
    setListeners: function() {
        $('.thumbnail-gallery__thumb--video').click(function(e) {
            e.preventDefault();

            var url = $(this).data('src');
            var type = $(this).data('type');

            var content = $('<div class="video video--'+ type +'">')
                .append($('<iframe class="video__iframe" src="' + url + '">'));

            overlay.apply(content);
        });
    }
};

videoOverlay.init();


// Forms
var newsletter = {
    form: null,
    init: function() {
        newsletter.form = $('.js-newsletter-form');
        newsletter.setListeners();
    },
    setListeners: function() {
        newsletter.form.submit(function(e) {
            e.preventDefault();
            newsletter.removeErrors();
            var submitted = $(this);
            if (!$('#customer_email', newsletter.form).val()) {
                newsletter.addError('Please enter a valid email address');
            } else {
                $.ajax({
                    url: submitted.attr('action'),
                    type: 'POST',
                    data: submitted.serialize(),
                    success: function (data) {
                        if (data.result) {
                            if (typeof ga !== 'undefined') {
                                ga('send', 'event', 'Newsletter', 'Submit', 'Footer Form');
                            }
                            var wrap = submitted.find('.newsletter-form__wrap');
                            $('.newsletter-form__success-message').css('min-height', wrap.css('height'));
                            submitted.find('.newsletter-form__wrap').fadeOut(function() {
                                $('.newsletter-form__success-message').fadeIn();
                            });
                        } else {
                            newsletter.addError(data.message);
                        }
                    }
                });
            }
        });
    },
    addError: function(message) {
        // Clear the error before adding a new one.
        newsletter.removeErrors();
        $('#customer_email_wrap', newsletter.form)
            .addClass('field-error')
            .append('<p class="error footer-signup-error">'+ message +'</p>');

        newsletter.focusInput();
    },
    focusInput: function() {
        $('#customer_email', newsletter.form).focus();
    },
    removeErrors: function() {
        $('.error', newsletter.form).remove();
        $('#customer_email_wrap', newsletter.form)
            .removeClass('field-error');
    }
};

$(function() {
    header.init();
    newsletter.init();
    accordion.init();
    filters.init();
    nav.init();
});

$(window).on("load", function() {
    svg4everybody();
    cards.init();
});

// Open external links in a new tab
$(function() {
    $(document).on('click', 'a.external, .external a',function(e) {
        e.preventDefault();
        window.open($(this).attr('href'));
    });
});

$(function() {
    var sticky = document.querySelectorAll('.is-sticky');

    if (sticky.length > 0) {
        document.querySelector('.outer-wrapper').classList.add('outer-wrapper--visible');
    }
});

$(function() {
    $('.js-product-listing').each(function() {
        var listing = $(this);
        var link = $(this).find('a');

        $(this).find('a').hover(function() {
            listing.addClass('product-listing--hover');
        }, function() {
            listing.removeClass('product-listing--hover');
        });
    });
});

(function (app) {
    document.querySelectorAll('.js-tool-tip').forEach(function (element, index) {
        var button = element.querySelector('.tool-tip__icon');
        var content = element.querySelector('.tool-tip__content');

        button.classList.add('js-reveal');
        button.setAttribute('aria-controls', 'tool-tip-'+index);
        content.setAttribute('id', 'tool-tip-'+index);
        content.setAttribute('hidden', '');
    });

    app.plugins.delegate(
        document,
        'click',
        '.js-reveal',
        function (event) {
            event.preventDefault();
            var target = event.target.closest('.js-reveal');
            var content = document.getElementById(target.getAttribute('aria-controls'));

            if (!content) {
                return;
            }

            var expanded = target.getAttribute('aria-expanded') === 'true';
            target.setAttribute('aria-expanded', expanded ? 'false' : 'true');

            if (expanded) {
                content.setAttribute('hidden', '');
            } else {
                content.removeAttribute('hidden');
            }
        }
    );

    app.plugins.delegate(
        document,
        'click',
        '.js-reveal-trigger',
        function (event) {
            var id = event.target.getAttribute('data-reveal');

            if (id) {
                var target = document.querySelector('.js-reveal[data-reveal="' + id + '"]');

                if (target) {
                    $(window).scrollTop($(target).offset().top - $('.header').height());
                    if (target.getAttribute('aria-expanded') === 'false') {
                        target.click();
                    }
                }
            }
        }
    );
})(window.Bespoke = window.Bespoke || {});

(function() {
    var table = document.querySelector('.bike-fit-comparison__table');

    if (table) {
        var body = document.querySelector('body');

        if (body) {
            body.classList.add('body--flush');
        }
    }
})();
